<template>
  <section>
    <el-tabs v-model="activeName" type="card">

      <!-- Tab 1: To Confirm (待确认批次) -->
      <el-tab-pane label="To Confirm" name="toConfirm">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="filters">
            <el-form-item>
              <el-select
                v-model="filters.batchFilter"
                placeholder="Select Batch Number (Type 2+ chars to search)"
                clearable
                filterable
                remote
                :remote-method="searchPendingBatchNumbers"
                :loading="availableBatchesLoading"
                @change="handlePendingBatchNumberChange"
                @visible-change="handlePendingBatchDropdownVisible"
                @clear="handlePendingBatchNumberClear"
                style="width: 340px;">
                <el-option
                  v-for="batch in availableBatches"
                  :key="batch.batchNumber"
                  :label="batch.batchNumber"
                  :value="batch.batchNumber">
                  <span class="batch-number">{{ batch.batchNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="filters.trackingFilter"
                placeholder="Tracking #"
                clearable
                @keyup.enter.native="getPendingPackages">
                <el-button slot="append" icon="el-icon-search" @click="getPendingPackages"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="showBatchImport">Batch Import</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="showBulkConfirm">Bulk Confirm</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="showBatchCancel">Batch Remove</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="exportPendingBatches">Export</el-button>
            </el-form-item>
          </el-form>
        </el-col>

        <!-- 待确认包裹列表 (按批次号 + Tracking维度) -->
        <el-table
          stripe
          :data="pendingPackageList"
          highlight-current-row
          v-loading="pendingBatchLoading"
          style="width: 100%;"
          @selection-change="handlePackageSelection">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="batchNumber" label="Batch Number" min-width="140"></el-table-column>
          <el-table-column prop="tracking" label="Tracking Number" min-width="180">
            <template slot-scope="scope">
              <p><strong>{{scope.row.tracking}}</strong></p>
              <p class="note" v-if="scope.row.note">{{scope.row.note}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="itemCount" label="UPC Items" width="80" align="center"></el-table-column>
          <el-table-column prop="warehouseName" label="Warehouse" min-width="120"></el-table-column>
          <el-table-column prop="importDate" label="Import Time" min-width="140"></el-table-column>
          <el-table-column label="Action" width="240" fixed="right">
            <template slot-scope="scope">
              <div style="white-space: nowrap;">
                <el-button size="mini" type="primary" @click="viewPendingPackageDetail(scope.row)">Detail</el-button>
                <el-button size="mini" type="success" @click="confirmSinglePackage(scope.row)">Confirm</el-button>
                <el-button size="mini" type="danger" @click="cancelSinglePackage(scope.row)">Remove</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-col :span="24" class="toolbar">
          <el-pagination
            @size-change="handlePendingBatchSizeChange"
            @current-change="changePendingBatchPage"
            :current-page="currentPendingBatchPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="dynamicPendingPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pendingBatchTotal">
          </el-pagination>
          <div v-if="filters.batchFilter" style="margin-top: 10px; color: #909399; font-size: 12px;">
            <i class="el-icon-info"></i> Filtered by batch, showing 50 items per page
          </div>
        </el-col>
      </el-tab-pane>

      <!-- Tab 2: Mixed Packages (混寄包裹管理) -->
      <el-tab-pane label="Mixed Packages" name="packages">
        <!-- Filter conditions row -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="packageFilters">
            <el-form-item>
              <el-select
                v-model="packageFilters.batchNumber"
                placeholder="Select Batch Number (Type 2+ chars to search)"
                clearable
                filterable
                remote
                :remote-method="searchBatchNumbers"
                :loading="mixedPackageBatchesLoading"
                @change="handleBatchNumberChange"
                @visible-change="handleBatchDropdownVisible"
                @clear="handleBatchNumberClear"
                style="width: 340px;">
                <el-option
                  v-for="batch in mixedPackageBatches"
                  :key="batch.batchNumber"
                  :label="batch.batchNumber"
                  :value="batch.batchNumber">
                  <span class="batch-number">{{ batch.batchNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="packageFilters.tracking"
                placeholder="Tracking Number"
                clearable
                @keyup.enter.native="getMixedPackageList">
                <el-button slot="append" icon="el-icon-search" @click="getMixedPackageList"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="packageFilters.upc"
                placeholder="Full UPC"
                clearable
                @keyup.enter.native="getMixedPackageList">
                <el-button slot="append" icon="el-icon-search" @click="getMixedPackageList"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="packageFilters.warehouseNo" placeholder="Warehouse" clearable>
                <el-option
                  v-for="warehouse in warehouses"
                  :key="warehouse.warehouseNo"
                  :label="warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address"
                  :value="warehouse.warehouseNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="packageFilters.packageStatus" placeholder="Status" clearable>
                <el-option label="Pending" value="0"></el-option>
                <el-option label="Partial Claimed" value="1"></el-option>
                <el-option label="All Claimed" value="2"></el-option>
                <el-option label="Completed" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>

        <!-- Action buttons row -->
        <el-col :span="24" class="toolbar" style="padding-top: 0px;">
          <el-form :inline="true">
            <el-form-item>
              <el-button type="primary" @click="showCreatePackage">Create Mixed Package</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="warning" @click="showBulkReverse" :disabled="selectedPackages.length === 0">
                Bulk Reverse ({{selectedPackages.length}})
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="exportMixedPackages">Export</el-button>
            </el-form-item>
            <!-- Temporarily hidden - Bulk Reverse by Batch feature -->
            <!-- <el-form-item>
              <el-button type="danger" @click="showBatchBulkReverse">
                Bulk Reverse by Batch
              </el-button>
            </el-form-item> -->
          </el-form>
        </el-col>

        <!-- 混寄包裹列表 -->
        <el-table
          stripe
          :data="packageList"
          highlight-current-row
          v-loading="packageLoading"
          style="width: 100%;"
          @selection-change="handlePackageSelection">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="tracking" label="Tracking #" min-width="200">
            <template slot-scope="scope">
              <p><strong>{{scope.row.tracking}}</strong></p>
              <p class="batch-number-display" v-if="scope.row.batchNumber">
                <el-tag type="info" size="mini">Batch: {{ scope.row.batchNumber }}</el-tag>
              </p>
              <p class="note" v-if="scope.row.note">{{scope.row.note}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="warehouse" label="Warehouse" min-width="150">
          </el-table-column>
          <el-table-column label="Items Status" min-width="180">
            <template slot-scope="scope">
              <p>Total: {{scope.row.totalItems}} items</p>
              <p>Claimed: {{scope.row.claimedItems}} items</p>
              <p>Remaining: {{scope.row.unclaimedItems}} items</p>
            </template>
          </el-table-column>
          <el-table-column label="Package Status" min-width="120">
            <template slot-scope="scope">
              <el-tag
                :type="getStatusTagType(scope.row.packageStatus)"
                size="small">
                {{getStatusText(scope.row.packageStatus)}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="Create Date" min-width="180">
            <template slot-scope="scope">
              <p>{{formatDate(scope.row.createDate)}}</p>
              <p class="note">by {{scope.row.createUserName}}</p>
            </template>
          </el-table-column>
          <el-table-column label="Actions" min-width="280">
            <template slot-scope="scope">
              <el-button size="mini" @click="viewPackageDetail(scope.row)">View Details</el-button>
              <el-button
                size="mini"
                type="success"
                v-if="scope.row.packageStatus >= 1"
                @click="viewClaimsForPackage(scope.row)">
                View Claims
              </el-button>
              <el-button
                size="mini"
                type="warning"
                @click="confirmReversePackage(scope.row)">
                Reverse
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-col :span="24" class="toolbar">
          <el-pagination
            @size-change="handlePackageSizeChange"
            @current-change="handlePackageCurrentChange"
            :current-page="packageCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="packageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="packageTotal">
          </el-pagination>
        </el-col>
      </el-tab-pane>

      <!-- Tab 3: Claims Review (认领审核管理) -->
      <el-tab-pane name="claims">
        <span slot="label">
          Claims Review
          <el-badge
            :value="pendingClaimsCount"
            :hidden="pendingClaimsCount === 0"
            class="item">
          </el-badge>
        </span>

        <!-- Filter conditions row -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="claimFilters">
            <el-form-item>
              <el-select
                v-model="claimFilters.batchNumber"
                placeholder="Select Batch Number (Type 2+ chars to search)"
                clearable
                filterable
                remote
                :remote-method="searchClaimsBatchNumbers"
                :loading="claimsBatchesLoading"
                @change="handleClaimsBatchNumberChange"
                @visible-change="handleClaimsBatchDropdownVisible"
                @clear="handleClaimsBatchNumberClear"
                style="width: 340px;">
                <el-option
                  v-for="batch in claimsBatches"
                  :key="batch.batchNumber"
                  :label="batch.batchNumber"
                  :value="batch.batchNumber">
                  <span class="batch-number">{{ batch.batchNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="claimFilters.tracking"
                placeholder="Tracking Number"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="claimFilters.upc"
                placeholder="UPC"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="claimFilters.warehouseNo" placeholder="Warehouse" clearable>
                <el-option
                  v-for="warehouse in claimWarehouses"
                  :key="warehouse.warehouseNo"
                  :label="warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address"
                  :value="warehouse.warehouseNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="claimFilters.claimStatus" placeholder="Claim Status" clearable>
                <el-option label="Pending Review" value="0"></el-option>
                <el-option label="Approved" value="1"></el-option>
                <el-option label="Distributed" value="2"></el-option>
                <el-option label="Rejected" value="3"></el-option>
                <el-option label="Quantity Adjusted" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getClaimList">Search</el-button>
            </el-form-item>
          </el-form>
        </el-col>

        <!-- Action buttons row -->
        <el-col :span="24" class="toolbar" style="padding-top: 0px;">
          <el-form :inline="true">
            <el-form-item>
              <el-button
                type="success"
                @click="showBatchApprove"
                :disabled="!canBatchApprove">
                Batch Approve ({{approvableClaimsCount}})
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="danger"
                @click="showBatchReject"
                :disabled="!canBatchReject">
                Batch Reject ({{rejectableClaimsCount}})
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="showBatchDistribute"
                :disabled="!canBatchDistribute">
                Batch Distribute ({{distributableClaimsCount}})
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="warning"
                @click="showSetChargeTime"
                :disabled="!canSetForceChargeTime">
                Set Charge Time ({{chargeEditableClaimsCount}})
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="exportClaimList">Export</el-button>
            </el-form-item>
          </el-form>
        </el-col>

        <!-- 认领列表 -->
        <el-table
          stripe
          :data="claimList"
          highlight-current-row
          v-loading="claimLoading"
          style="width: 100%;"
          ref="claimTable"
          @selection-change="handleClaimSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="tracking" label="Tracking #" min-width="150">
          </el-table-column>
          <el-table-column prop="upc" label="UPC" min-width="150">
          </el-table-column>
          <el-table-column prop="warehouse" label="Warehouse" min-width="160">
          </el-table-column>
          <el-table-column label="Claimer" min-width="160">
            <template slot-scope="scope">
              <p>{{scope.row.claimerName}}</p>
              <el-tag size="mini" :type="scope.row.claimerType === 1 ? 'success' : 'info'">
                {{scope.row.claimerTypeDesc}}
              </el-tag>
              <p v-if="scope.row.claimerType === 2 && scope.row.targetDoctorName" style="margin-top: 4px; font-size: 12px; color: #606266;">
                <i class="el-icon-user"></i> Doctor: {{scope.row.targetDoctorName}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="Quantity Info" min-width="160">
            <template slot-scope="scope">
              <p>Claimed:
                <el-tag
                  :type="getQuantityTagType(scope.row)"
                  size="mini">
                  {{scope.row.claimedQty}}
                </el-tag>
              </p>
              <p>Available:
                <el-tag
                  v-if="scope.row.unclaimedQty < 0"
                  type="danger"
                  size="mini"
                  class="negative-quantity-alert">
                  <i class="el-icon-warning"></i> {{scope.row.unclaimedQty}}
                </el-tag>
                <span v-else>{{scope.row.unclaimedQty}}</span>
              </p>
              <p>Total: {{scope.row.totalQty}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="claimDate" label="Claim Date" min-width="140">
            <template slot-scope="scope">
              {{formatDate(scope.row.claimDate)}}
            </template>
          </el-table-column>
          <el-table-column label="Status" min-width="100">
            <template slot-scope="scope">
              <el-tag
                :type="getClaimStatusTagType(scope.row.claimStatus)"
                size="small">
                {{getClaimStatusText(scope.row.claimStatus)}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Charge Time" min-width="140">
            <template slot-scope="scope">
              <div class="charge-time-display">
                <div v-if="scope.row.forceChargeTime" class="charge-time-forced">
                  <i class="el-icon-time"></i>
                  Force: {{formatDate(scope.row.forceChargeTime)}}
                </div>
                <div v-else class="charge-time-normal">
                  <i class="el-icon-clock"></i>
                  Normal Period
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Actions" min-width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.claimStatus === 0">
                <el-button size="mini" type="success" @click="approveClaim(scope.row)">Approve</el-button>
                <el-button size="mini" type="warning" @click="showAdjustQuantity(scope.row)">Adjust</el-button>
                <el-button size="mini" type="danger" @click="showRejectClaim(scope.row)">Reject</el-button>
              </div>
              <div v-else-if="scope.row.claimStatus === 1">
                <el-button size="mini" type="primary" @click="showSingleDistribute(scope.row)">Distribute</el-button>
                <el-button size="mini" type="danger" @click="showRejectClaim(scope.row)" title="Reject this claim if you find errors before distribution">Reject</el-button>
                <el-button size="mini" @click="viewClaimDetail(scope.row)">View Detail</el-button>
                <el-button size="mini" type="warning" @click="rollbackClaimToPending(scope.row)" title="Rollback this claim to pending status for re-processing">Rollback</el-button>
              </div>
              <div v-else-if="scope.row.claimStatus === 2">
                <el-button size="mini" @click="viewClaimDetail(scope.row)">View Detail</el-button>
                <el-button size="mini" type="warning" @click="rollbackClaimToPending(scope.row)" title="Rollback this claim to pending status for re-processing">Rollback</el-button>
              </div>
              <div v-else-if="scope.row.claimStatus === 4">
                <el-button size="mini" type="primary" @click="showSingleDistribute(scope.row)">Distribute</el-button>
                <el-button size="mini" type="danger" @click="showRejectClaim(scope.row)" title="Reject this claim if you find errors before distribution">Reject</el-button>
                <el-button size="mini" @click="viewClaimDetail(scope.row)">View Detail</el-button>
                <el-button size="mini" type="warning" @click="rollbackClaimToPending(scope.row)" title="Rollback this claim to pending status for re-processing">Rollback</el-button>
              </div>
              <div v-else>
                <el-button size="mini" @click="viewClaimDetail(scope.row)">View Detail</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-col :span="24" class="toolbar">
          <el-pagination
            @size-change="handleClaimSizeChange"
            @current-change="handleClaimCurrentChange"
            :current-page="claimCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="claimSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="claimTotal">
          </el-pagination>
        </el-col>
      </el-tab-pane>

      <!-- Tab 4: Unclaimed Items (未认领商品) -->
      <el-tab-pane label="Unclaimed Items" name="unclaimed">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="unclaimedFilters">
            <el-form-item>
              <el-input
                v-model="unclaimedFilters.upc"
                placeholder="UPC"
                clearable
                @keyup.enter.native="getUnclaimedItemsList">
                <el-button slot="append" icon="el-icon-search" @click="getUnclaimedItemsList"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="exportUnclaimed">Export</el-button>
            </el-form-item>
          </el-form>
        </el-col>

        <!-- 未认领商品列表 -->
        <el-table
          stripe
          :data="unclaimedList"
          highlight-current-row
          v-loading="unclaimedLoading"
          style="width: 100%;">
          <el-table-column prop="upc" label="UPC" min-width="180"></el-table-column>
          <el-table-column prop="productName" label="Product Name" min-width="200"></el-table-column>
          <el-table-column prop="unclaimedQty" label="Unclaimed Qty" min-width="120">
            <template slot-scope="scope">
              <el-tag type="warning" size="small">{{scope.row.unclaimedQty}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="totalPackages" label="Packages Count" min-width="130"></el-table-column>
          <el-table-column prop="trackingList" label="Related Trackings" min-width="300">
            <template slot-scope="scope">
              <div class="tracking-list-container">
                <div v-if="getTrackingArray(scope.row.trackingList).length <= 2" class="tracking-simple">
                  <el-tooltip
                    v-for="(tracking, index) in getTrackingArray(scope.row.trackingList)"
                    :key="index"
                    effect="dark"
                    :content="tracking"
                    placement="top">
                    <el-tag
                      size="mini"
                      type="info"
                      class="tracking-tag">
                      {{getDisplayTracking(tracking)}}
                    </el-tag>
                  </el-tooltip>
                </div>
                <div v-else class="tracking-with-more">
                  <el-tooltip
                    v-for="(tracking, index) in getTrackingArray(scope.row.trackingList).slice(0, 2)"
                    :key="index"
                    effect="dark"
                    :content="tracking"
                    placement="top">
                    <el-tag
                      size="mini"
                      type="info"
                      class="tracking-tag">
                      {{getDisplayTracking(tracking)}}
                    </el-tag>
                  </el-tooltip>
                  <el-popover
                    placement="top"
                    width="400"
                    trigger="hover">
                    <div class="tracking-popover">
                      <p class="popover-title">All Related Tracking Numbers ({{getTrackingArray(scope.row.trackingList).length}})</p>
                      <div class="tracking-grid">
                        <el-tag
                          v-for="(tracking, index) in getTrackingArray(scope.row.trackingList)"
                          :key="index"
                          size="small"
                          type="info"
                          class="tracking-tag-full">
                          {{tracking}}
                        </el-tag>
                      </div>
                    </div>
                    <el-tag
                      slot="reference"
                      size="mini"
                      type="warning"
                      class="tracking-more-tag">
                      +{{getTrackingArray(scope.row.trackingList).length - 2}} more
                    </el-tag>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-col :span="24" class="toolbar">
          <el-pagination
            @size-change="handleUnclaimedSizeChange"
            @current-change="handleUnclaimedCurrentChange"
            :current-page="unclaimedCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="unclaimedSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="unclaimedTotal">
          </el-pagination>
        </el-col>
      </el-tab-pane>

    </el-tabs>

    <!-- 批量导入对话框 -->
    <el-dialog
      title="Batch Import Mixed Packages"
      width="80%"
      :visible.sync="batchImportDialogVisible"
      :close-on-click-modal="false">

      <el-form :model="importForm" :rules="importRules" ref="importForm" label-width="140px">
        <el-form-item label="Batch Number" prop="batchNumber">
          <el-input v-model="importForm.batchNumber" :disabled="true" placeholder="Loading..."></el-input>
        </el-form-item>

        <el-form-item label="Warehouse" prop="warehouseNo">
          <el-select v-model="importForm.warehouseNo" placeholder="Select warehouse" style="width: 100%;">
            <el-option
              v-for="warehouse in warehouses"
              :key="warehouse.warehouseNo"
              :label="warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address"
              :value="warehouse.warehouseNo">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Import Method">
          <el-radio-group v-model="importForm.importMethod">
            <el-radio label="text">Text Format</el-radio>
            <el-radio label="excel">Excel File</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- Text导入 -->
        <!-- Text导入 -->
        <el-form-item v-if="importForm.importMethod === 'text'" label="Package Data" prop="textContent">
          <el-input
            type="textarea"
            :rows="8"
            v-model="importForm.textContent"
            placeholder="Format: Tracking,UPC,Quantity or Tracking[Tab]UPC[Tab]Quantity (one per line)&#10;Example: 1Z999AA1234567890,123456789012,2">
          </el-input>
          <div class="import-hint">
            <i class="el-icon-info"></i>
            <span>Supports multi-line, tab-separated fields, comma-separated, and space-separated formats</span>
            <el-tooltip placement="right" effect="dark">
              <div slot="content">
                <div class="tooltip-format-guide">
                  <div><strong>📋 Supported Formats:</strong></div>
                  <br>
                  <div><strong>🔹 Multi-line comma-separated (Recommended):</strong></div>
                  <div class="tooltip-example">
                    1Z999AA1234567890,123456789012,2<br>
                    1Z888BB9876543210,987654321098,1<br>
                    1Z777CC5555555555,456789123456,3
                  </div>
                  <br>
                  <div><strong>🔹 Tab-separated fields (one per line):</strong></div>
                  <div class="tooltip-example">
                    1Z999AA1234567890[Tab]123456789012[Tab]2<br>
                    1Z888BB9876543210[Tab]987654321098[Tab]1<br>
                    Format: Tracking[Tab]UPC[Tab]Quantity
                  </div>
                  <br>
                  <div><strong>🔹 Space-separated packages (single line):</strong></div>
                  <div class="tooltip-example">
                    1Z999-AA1234567890,123456789012,2 1Z888-BB9876543210,987654321098,1
                  </div>
                  <br>
                  <div><strong>🔹 With spaces around commas:</strong></div>
                  <div class="tooltip-example">
                    1Z999-AA1234567890 , 123456789012 , 2<br>
                    1Z888-BB9876543210 , 987654321098 , 1
                  </div>
                  <br>
                  <div style="color: #E6A23C;"><strong>⚠️ Important:</strong> Each package needs exactly 3 fields (Tracking, UPC, Quantity)</div>
                  <div style="color: #67C23A; margin-top: 8px;"><strong>✓ Note:</strong> Extra spaces will be automatically cleaned up</div>
                </div>
              </div>
              <i class="el-icon-question hover-help-icon"></i>
            </el-tooltip>
          </div>
        </el-form-item>

        <!-- Excel导入 -->
        <!-- Excel导入 -->
        <el-form-item v-if="importForm.importMethod === 'excel'" label="Excel File" prop="excelFile">
          <el-upload
            ref="excelUpload"
            :action="excelUploadUrl"
            :headers="uploadHeaders"
            :data="excelUploadData"
            :on-success="handleExcelUploadSuccess"
            :on-error="handleExcelUploadError"
            :file-list="excelFileList"
            :limit="1"
            name="file"
            accept=".xlsx,.xls"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip">Only .xlsx/.xls files are supported</div>
          </el-upload>
          <div class="import-hint">
            <i class="el-icon-info"></i>
            <span>Excel format: Column A=Tracking, Column B=UPC, Column C=Quantity</span>
            <el-tooltip placement="right" effect="dark">
              <div slot="content">
                <div class="tooltip-format-guide">
                  <div><strong>📊 Excel File Requirements:</strong></div>
                  <br>
                  <div><strong>Required columns (in exact order):</strong></div>
                  <div class="tooltip-example">
                    <strong>Column A:</strong> Tracking Number<br>
                    <strong>Column B:</strong> UPC Code<br>
                    <strong>Column C:</strong> Quantity
                  </div>
                  <br>
                  <div><strong>Example:</strong></div>
                  <div class="tooltip-example">
                    A1: 1Z999AA1234567890&nbsp;&nbsp;&nbsp;&nbsp;B1: 123456789012&nbsp;&nbsp;&nbsp;&nbsp;C1: 2<br>
                    A2: 1Z888BB9876543210&nbsp;&nbsp;&nbsp;&nbsp;B2: 987654321098&nbsp;&nbsp;&nbsp;&nbsp;C2: 1
                  </div>
                  <br>
                  <div style="color: #E6A23C;"><strong>⚠️ Important:</strong> No headers, start with data from row 1</div>
                </div>
              </div>
              <i class="el-icon-question hover-help-icon"></i>
            </el-tooltip>
          </div>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBatchImportDialog">Cancel</el-button>
        <el-button type="primary" @click="validateImportData" :loading="importing">
          Import
        </el-button>
      </div>
    </el-dialog>

    <!-- 包裹详情对话框 (显示UPC维度详情) -->
    <el-dialog
      title="Package Detail & Management"
      width="95%"
      :visible.sync="batchDetailDialogVisible"
      :close-on-click-modal="false"
      class="package-detail-dialog">

      <div v-if="currentPackageDetail">
        <!-- 包裹信息摘要 -->
        <el-card class="batch-summary-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="header-title">
              <i class="el-icon-box"></i>
              Package Information
            </span>
            <div class="header-actions">
              <el-button style="padding: 3px 8px" type="text" @click="refreshPendingPackageDetail">
                <i class="el-icon-refresh"></i> Refresh
              </el-button>
            </div>
          </div>
          <!-- 第一行 -->
          <el-row :gutter="20" style="margin-bottom: 15px;">
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">Batch Number:</span>
                <el-tag type="info" size="small">{{ currentPackageDetail.batchNumber }}</el-tag>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="summary-item">
                <span class="label">Tracking Number:</span>
                <code class="tracking-code">{{ currentPackageDetail.tracking }}</code>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="summary-item">
                <span class="label">Total UPC Items:</span>
                <el-tag type="success" size="small">{{ currentPackageDetail.itemCount }}</el-tag>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="summary-item">
                <span class="label">UPC Types:</span>
                <el-tag type="primary" size="small">{{ (currentPackageDetail.items || []).length }}</el-tag>
              </div>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="summary-item">
                <span class="label">Status:</span>
                <el-tag :type="getBatchStatusType(currentPackageDetail.status)">{{ currentPackageDetail.status }}</el-tag>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="summary-item">
                <span class="label">Warehouse:</span>
                <span class="value">{{ currentPackageDetail.warehouseName }}</span>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="summary-item">
                <span class="label">Import Date:</span>
                <span class="value">{{ currentPackageDetail.importDate }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- UPC商品列表 -->
        <el-card class="items-card" shadow="never" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span class="header-title">
              <i class="el-icon-goods"></i>
              UPC Items Management ({{ (currentPackageDetail.items || []).length }} items)
            </span>
            <div class="header-actions" v-if="currentPackageDetail.status === 'pending'">
              <el-button
                size="small"
                type="danger"
                icon="el-icon-delete"
                :disabled="selectedUPCs.length === 0"
                @click="bulkDeleteUPCs">
                Delete Selected ({{ selectedUPCs.length }})
              </el-button>
            </div>
          </div>

          <el-table
            :data="currentPackageDetail.items || []"
            v-loading="batchDetailLoading"
            ref="upcTable"
            @selection-change="handleUPCSelectionChange"
            row-key="upc"
            style="width: 100%;">

            <el-table-column
              v-if="currentPackageDetail.status === 'pending'"
              type="selection"
              width="55">
            </el-table-column>

            <el-table-column prop="upc" label="UPC Code" min-width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.upc }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="productName" label="Product Name" min-width="250">
              <template slot-scope="scope">
                <span v-if="scope.row.productName" class="product-name">{{ scope.row.productName }}</span>
                <span v-else class="no-data">No product info</span>
              </template>
            </el-table-column>

            <el-table-column prop="quantity" label="Quantity" width="100" align="center">
              <template slot-scope="scope">
                <el-tag type="success" size="medium">{{ scope.row.quantity }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="status" label="Status" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 'pending' ? 'warning' : 'success'" size="small">
                  {{ scope.row.status }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="importDate" label="Import Time" min-width="140">
              <template slot-scope="scope">
                <span class="import-time">{{ scope.row.importDate }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Validation" min-width="120" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.errorMessage" class="validation-error">
                  <el-tooltip :content="scope.row.errorMessage" placement="top">
                    <el-tag type="danger" size="small">
                      <i class="el-icon-warning"></i> Error
                    </el-tag>
                  </el-tooltip>
                </div>
                <div v-else class="validation-success">
                  <el-tag type="success" size="small">
                    <i class="el-icon-circle-check"></i> Valid
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="currentPackageDetail.status === 'pending'"
              label="Actions"
              width="150"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editSingleUPC(scope.row, scope.$index)"
                  title="Edit this UPC"
                  style="margin-right: 5px;">
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="deleteSingleUPC(scope.row, scope.$index)"
                  title="Remove this UPC from package">
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <i class="el-icon-box"></i>
        <p>No package detail available</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <div class="footer-left">
          <span v-if="currentPackageDetail && currentPackageDetail.items" class="item-count-info">
            Total: {{ currentPackageDetail.items.length }} UPC types,
            {{ currentPackageDetail.items.reduce((sum, item) => sum + item.quantity, 0) }} items
          </span>
        </div>
        <div class="footer-right">
          <el-button @click="batchDetailDialogVisible = false">Close</el-button>
          <el-button
            v-if="currentPackageDetail && currentPackageDetail.status === 'pending'"
            type="success"
            @click="confirmBatchFromDetail"
            icon="el-icon-check">
            Confirm This Package
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 批量确认对话框 -->
    <el-dialog
      title="Bulk Confirm Packages"
      width="70%"
      :visible.sync="bulkConfirmDialogVisible"
      :close-on-click-modal="false">

      <div v-if="selectedPackages.length > 0">
        <el-alert
          :title="`You are about to confirm ${selectedPackages.length} package(s)`"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        </el-alert>

        <el-table :data="selectedPackages" style="width: 100%;">
          <el-table-column prop="batchNumber" label="Batch Number" min-width="140"></el-table-column>
          <el-table-column prop="tracking" label="Tracking Number" min-width="180"></el-table-column>
          <el-table-column prop="itemCount" label="UPC Items" width="80" align="center"></el-table-column>
          <el-table-column prop="warehouseName" label="Warehouse" min-width="120"></el-table-column>
          <el-table-column prop="importDate" label="Import Date" min-width="140"></el-table-column>
        </el-table>


        <div style="margin-top: 10px; color: #909399; font-size: 13px;">
          <i class="el-icon-warning"></i>
          This operation will confirm and create mixed packages from all selected packages. This action cannot be undone.
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="bulkConfirmDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="executeBulkConfirm" :loading="bulkConfirming">
          Confirm All Packages
        </el-button>
      </div>
    </el-dialog>

    <!-- 包裹详情对话框 -->
    <el-dialog
      title="Package Detail"
      width="90%"
      :visible.sync="packageDetailDialogVisible"
      :close-on-click-modal="false">

      <div v-if="currentPackageDetail">
        <!-- 包裹基本信息 -->
        <el-card class="package-info-card" shadow="never">
          <div slot="header" class="clearfix">
            <span><strong>Package Information</strong></span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="refreshMixedPackageDetail">
              <i class="el-icon-refresh"></i> Refresh
            </el-button>
          </div>
          <el-table :data="packageInfoRows" border style="width: 100%;" :show-header="false">
            <el-table-column prop="label1" width="120" class-name="info-label-cell">
              <template slot-scope="scope">
                <strong>{{ scope.row.label1 }}</strong>
              </template>
            </el-table-column>
            <el-table-column prop="value1" min-width="160" class-name="info-value-cell">
              <template slot-scope="scope">
                <span v-if="scope.row.label1 === 'Status:'">
                  <el-tag :type="getPackageStatusType(currentPackageDetail.packageStatus)">
                    {{ scope.row.value1 }}
                  </el-tag>
                </span>
                <span v-else>{{ scope.row.value1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="label2" width="120" class-name="info-label-cell">
              <template slot-scope="scope">
                <strong>{{ scope.row.label2 }}</strong>
              </template>
            </el-table-column>
            <el-table-column prop="value2" min-width="160" class-name="info-value-cell"></el-table-column>
            <el-table-column prop="label3" width="120" class-name="info-label-cell">
              <template slot-scope="scope">
                <strong>{{ scope.row.label3 }}</strong>
              </template>
            </el-table-column>
            <el-table-column prop="value3" min-width="160" class-name="info-value-cell"></el-table-column>
          </el-table>
        </el-card>

        <!-- 商品详情列表 -->
        <el-card class="package-items-card" shadow="never" style="margin-top: 20px;">
          <div slot="header">
            <span><strong>Package Items</strong></span>
          </div>
          <el-table
            :data="currentPackageDetail.details || []"
            v-loading="packageDetailLoading"
            style="width: 100%;">
            <el-table-column prop="upc" label="UPC" min-width="140"></el-table-column>
            <el-table-column prop="productName" label="Product Name" min-width="200"></el-table-column>
            <el-table-column prop="totalQty" label="Total Qty" width="100" align="center"></el-table-column>
            <el-table-column prop="claimedQty" label="Claimed" width="100" align="center"></el-table-column>
            <el-table-column prop="unclaimedQty" label="Remaining" width="100" align="center">
              <template slot-scope="scope">
                <span :class="{'text-warning': scope.row.unclaimedQty > 0}">{{ scope.row.unclaimedQty }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="detailStatus" label="Status" width="120" align="center">
              <template slot-scope="scope">
                <el-tag :type="getDetailStatusTagType(scope.row.detailStatus)" size="small">
                  {{ getDetailStatusText(scope.row.detailStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="130" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="showEditUPCQty(scope.row)">
                  Edit UPC Qty
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <!-- 认领记录列表 -->
        <el-card class="package-claims-card" shadow="never" style="margin-top: 20px;">
          <div slot="header">
            <span><strong>Claim Records</strong></span>
          </div>
          <el-table
            :data="currentPackageDetail.claims || []"
            v-loading="packageDetailLoading"
            style="width: 100%;">
            <el-table-column label="Claimer" min-width="150">
              <template slot-scope="scope">
                <p>{{ scope.row.claimerName }}</p>
                <el-tag size="mini" :type="scope.row.claimerType === 1 ? 'success' : 'info'">
                  {{ scope.row.claimerTypeDesc }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="upc" label="UPC" min-width="150"></el-table-column>
            <el-table-column prop="claimedQty" label="Claimed Qty" width="100" align="center"></el-table-column>
            <el-table-column label="Status" width="120" align="center">
              <template slot-scope="scope">
                <el-tag :type="getClaimStatusTagType(scope.row.claimStatus)" size="small">
                  {{ getClaimStatusText(scope.row.claimStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="claimDate" label="Claim Date" min-width="150">
              <template slot-scope="scope">
                {{ formatDate(scope.row.claimDate) }}
              </template>
            </el-table-column>
            <el-table-column label="Distribute Date" min-width="160">
              <template slot-scope="scope">
                <div v-if="scope.row.distributeDate" class="distribute-date">
                  <i class="el-icon-box"></i>
                  <span>{{ formatDate(scope.row.distributeDate) }}</span>
                </div>
                <span v-else class="note">Not distributed</span>
              </template>
            </el-table-column>
            <el-table-column prop="reviewReason" label="Review Note" min-width="200"></el-table-column>
          </el-table>
        </el-card>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="packageDetailDialogVisible = false">Close</el-button>
        <el-button
          v-if="currentPackageDetail && currentPackageDetail.packageStatus === 'active'"
          type="warning"
          @click="reversePackageFromDetail">
          Reverse Package
        </el-button>
      </div>
    </el-dialog>

    <!-- 批量审批对话框 -->
    <el-dialog
      title="Batch Approve Claims"
      width="70%"
      :visible.sync="batchApproveDialogVisible"
      :close-on-click-modal="false">

      <div v-if="selectedClaims.length > 0">
        <el-alert
          :title="`You are about to approve ${selectedClaims.length} claim(s)`"
          type="info"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        </el-alert>

        <el-table :data="selectedClaims" style="width: 100%;">
          <el-table-column prop="claimId" label="Claim ID" width="100" align="center"></el-table-column>
          <el-table-column prop="tracking" label="Tracking" min-width="140"></el-table-column>
          <el-table-column prop="upc" label="UPC" min-width="140"></el-table-column>
          <el-table-column prop="claimerName" label="Claimer" min-width="120"></el-table-column>
          <el-table-column prop="claimedQty" label="Quantity" width="100" align="center"></el-table-column>
          <el-table-column prop="claimDate" label="Claim Date" min-width="140"></el-table-column>
        </el-table>

        <div style="margin-top: 20px; color: #909399; font-size: 13px;">
          <i class="el-icon-info-filled"></i>
          This operation will approve all selected claims. Approved claims can then be distributed.
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchApproveDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="executeBatchApprove" :loading="batchApproving">
          Approve All Claims
        </el-button>
      </div>
    </el-dialog>

    <!-- 批量下放对话框 -->
    <el-dialog
      title="Batch Distribute Claims"
      width="70%"
      :visible.sync="batchDistributeDialogVisible"
      :close-on-click-modal="false">

      <div v-if="selectedClaims.length > 0">
        <el-alert
          :title="`You are about to distribute ${selectedClaims.length} claim(s) to inventory`"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        </el-alert>

        <el-table :data="selectedClaims" style="width: 100%;">
          <el-table-column prop="claimId" label="Claim ID" width="100" align="center"></el-table-column>
          <el-table-column prop="tracking" label="Tracking" min-width="140"></el-table-column>
          <el-table-column prop="upc" label="UPC" min-width="140"></el-table-column>
          <el-table-column prop="claimerName" label="Claimer" min-width="120"></el-table-column>
          <el-table-column prop="claimedQty" label="Quantity" width="100" align="center"></el-table-column>
          <el-table-column prop="claimStatusDesc" label="Status" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getClaimStatusType(scope.row.claimStatus)" size="small">
                {{ scope.row.claimStatusDesc }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>


        <div style="margin-top: 10px; color: #909399; font-size: 13px;">
          <i class="el-icon-warning"></i>
          This operation will distribute inventory to claimers and generate FBM records for billing. This action cannot be undone.
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDistributeDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="executeBatchDistribute" :loading="batchDistributing">
          Distribute All Claims
        </el-button>
      </div>
    </el-dialog>

    <!-- 调整认领对话框 -->
    <el-dialog
      title="Adjust Claim Quantity"
      width="50%"
      :visible.sync="adjustClaimDialogVisible"
      :close-on-click-modal="false">

      <div v-if="currentClaimForAdjust">
        <el-form :model="adjustForm" :rules="adjustRules" ref="adjustForm" label-width="120px">
          <el-form-item label="Claim ID:">
            <span>{{ currentClaimForAdjust.claimId }}</span>
          </el-form-item>
          <el-form-item label="Tracking:">
            <span>{{ currentClaimForAdjust.tracking }}</span>
          </el-form-item>
          <el-form-item label="UPC:">
            <span>{{ currentClaimForAdjust.upc }}</span>
          </el-form-item>
          <el-form-item label="Claimer:">
            <span>{{ currentClaimForAdjust.claimerName }}</span>
          </el-form-item>
          <el-form-item label="Original Qty:">
            <span>{{ currentClaimForAdjust.claimedQty }}</span>
          </el-form-item>
          <el-form-item label="New Quantity:" prop="newQuantity">
            <el-input-number
              v-model="adjustForm.newQuantity"
              :min="1"
              :max="currentClaimForAdjust.availableQty || 999"
              style="width: 200px;">
            </el-input-number>
            <span style="margin-left: 10px; color: #909399;">
              Available: {{ currentClaimForAdjust.availableQty || 0 }}
            </span>
          </el-form-item>
          <el-form-item label="Reason:" prop="adjustReason">
            <el-input
              v-model="adjustForm.adjustReason"
              type="textarea"
              :rows="3"
              placeholder="Please explain the reason for quantity adjustment">
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="adjustClaimDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="executeAdjustClaim" :loading="adjusting">
          Adjust Quantity
        </el-button>
      </div>
    </el-dialog>

    <!-- 拒绝认领对话框 -->
    <el-dialog
      title="Reject Claim"
      width="50%"
      :visible.sync="rejectClaimDialogVisible"
      :close-on-click-modal="false">

      <div v-if="currentClaimForReject">
        <el-form :model="rejectForm" :rules="rejectRules" ref="rejectForm" label-width="120px">
          <el-form-item label="Claim ID:">
            <span>{{ currentClaimForReject.claimId }}</span>
          </el-form-item>
          <el-form-item label="Tracking:">
            <span>{{ currentClaimForReject.tracking }}</span>
          </el-form-item>
          <el-form-item label="UPC:">
            <span>{{ currentClaimForReject.upc }}</span>
          </el-form-item>
          <el-form-item label="Claimer:">
            <span>{{ currentClaimForReject.claimerName }}</span>
          </el-form-item>
          <el-form-item label="Quantity:">
            <span>{{ currentClaimForReject.claimedQty }}</span>
          </el-form-item>
          <el-form-item label="Reject Reason:" prop="rejectReason">
            <el-input
              v-model="rejectForm.rejectReason"
              type="textarea"
              :rows="4"
              placeholder="Please explain why this claim is being rejected">
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectClaimDialogVisible = false">Cancel</el-button>
        <el-button type="danger" @click="executeRejectClaim" :loading="rejecting">
          Reject Claim
        </el-button>
      </div>
    </el-dialog>

    <!-- 设置强制收费时间对话框 -->
    <el-dialog
      title="Set Force Charge Time"
      width="60%"
      :visible.sync="forceChargeTimeDialogVisible"
      :close-on-click-modal="false">

      <div v-if="selectedClaims.length > 0">
        <el-alert
          :title="`Setting force charge time for ${selectedClaims.length} claim(s)`"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        </el-alert>

        <el-form :model="forceChargeForm" :rules="forceChargeRules" ref="forceChargeForm" label-width="140px">
          <el-form-item label="Force Charge Time:" prop="forceChargeTime">
            <el-date-picker
              v-model="forceChargeForm.forceChargeTime"
              type="datetime"
              placeholder="Select date and time"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 300px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Reason:" prop="reason">
            <el-input
              v-model="forceChargeForm.reason"
              type="textarea"
              :rows="3"
              placeholder="Please explain why force charge time is being set">
            </el-input>
          </el-form-item>
        </el-form>

        <div style="margin-top: 20px;">
          <h4>Selected Claims:</h4>
          <el-table :data="selectedClaims" style="width: 100%; margin-top: 10px;">
            <el-table-column prop="claimId" label="Claim ID" width="100" align="center"></el-table-column>
            <el-table-column prop="tracking" label="Tracking" min-width="140"></el-table-column>
            <el-table-column prop="claimerName" label="Claimer" min-width="120"></el-table-column>
            <el-table-column prop="claimStatusDesc" label="Status" width="120" align="center"></el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 15px; color: #909399; font-size: 13px;">
          <i class="el-icon-info-filled"></i>
          Force charge time will override the normal free storage period. Claims will start incurring storage fees from the specified time.
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="forceChargeTimeDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="executeSetForceChargeTime" :loading="settingForceCharge">
          Set Force Charge Time
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑UPC对话框 -->
    <el-dialog title="Edit UPC Item" :visible.sync="editUPCDialog" width="500px" :close-on-click-modal="false" @close="cancelUPCEdit">
      <el-form :model="editUPCForm" :rules="editUPCRules" ref="editUPCForm" label-width="120px">
        <el-form-item label="UPC Code" prop="upc">
          <el-input
            v-model="editUPCForm.upc"
            placeholder="Enter UPC code"
            :maxlength="50"
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="Quantity" prop="quantity">
          <el-input-number
            v-model="editUPCForm.quantity"
            :min="1"
            :max="9999"
            controls-position="right"
            style="width: 100%;">
          </el-input-number>
        </el-form-item>
        <el-form-item label="Original UPC">
          <el-input
            v-model="editUPCForm.originalUpc"
            :disabled="true"
            placeholder="Original UPC code">
          </el-input>
        </el-form-item>
        <el-form-item label="Original Qty">
          <el-input-number
            v-model="editUPCForm.originalQuantity"
            :disabled="true"
            controls-position="right"
            style="width: 100%;">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelUPCEdit">Cancel</el-button>
        <el-button type="primary" @click="saveUPCEdit" :loading="savingUPCEdit">
          Save Changes
        </el-button>
      </div>
    </el-dialog>

    <!-- 创建混寄包裹对话框 -->
    <el-dialog title="Create Mixed Package" :visible.sync="createPackageDialog" width="760px" :close-on-click-modal="false" @close="resetCreateForm">
      <el-form :model="createPackageForm" :rules="createPackageRules" ref="createPackageForm" label-width="120px">
        <el-form-item label="Tracking #" prop="tracking">
          <el-input v-model="createPackageForm.tracking" placeholder="Enter tracking number" style="width: 570px;"></el-input>
        </el-form-item>
        <el-form-item label="Warehouse" prop="warehouseNo">
          <el-select v-model="createPackageForm.warehouseNo" placeholder="Select warehouse" style="width: 570px;">
            <el-option
              v-for="(warehouse, index) in warehouses"
              :key="index"
              :label="warehouse.state + ' ' + warehouse.city + ' ' + warehouse.address"
              :value="warehouse.warehouseNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Items">
          <el-table :data="createPackageForm.items" style="width: 570px;" border>
            <el-table-column label="UPC" prop="upc" width="250px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.upc" placeholder="Enter UPC"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Quantity" prop="qty" width="160px">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.qty" :min="1" placeholder="Qty" style="width: 100%;"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="140px">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="removePackageItem(scope.$index)">Remove</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" @click="addPackageItem" style="margin-top: 10px;">Add Item</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelCreatePackage">Cancel</el-button>
        <el-button type="primary" @click="createMixedPackage" :loading="createPackageLoading">Create</el-button>
      </div>
    </el-dialog>

    <!-- 调整数量对话框 -->
    <el-dialog title="Adjust Claim Quantity" :visible.sync="adjustQuantityDialog" width="40%">
      <el-form :model="adjustQuantityForm" :rules="adjustQuantityRules" ref="adjustQuantityForm" label-width="140px">
        <el-form-item label="Original Qty">
          <span>{{adjustQuantityForm.originalQty}}</span>
        </el-form-item>
        <el-form-item label="New Quantity" prop="newQuantity">
          <el-input-number
            v-model="adjustQuantityForm.newQuantity"
            :min="0"
            :max="adjustQuantityForm.maxQty"
            placeholder="New quantity">
          </el-input-number>
          <p style="margin-top: 5px; color: #909399; font-size: 12px;">
            Max adjustable: {{adjustQuantityForm.maxQty}}
          </p>
        </el-form-item>
        <el-form-item label="Reason (Optional)" prop="reason">
          <el-input
            type="textarea"
            v-model="adjustQuantityForm.reason"
            placeholder="Enter adjustment reason (optional)">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="adjustQuantityDialog = false">Cancel</el-button>
        <el-button type="primary" @click="confirmAdjustQuantity" :loading="adjustQuantityLoading">Confirm</el-button>
      </div>
    </el-dialog>

    <!-- 拒绝认领对话框 -->
    <el-dialog title="Reject Claim" :visible.sync="rejectClaimDialog" width="40%">
      <el-form :model="rejectClaimForm" :rules="rejectClaimRules" ref="rejectClaimForm" label-width="100px">
        <el-form-item label="Reason" prop="reason">
          <el-input
            type="textarea"
            v-model="rejectClaimForm.reason"
            placeholder="Please enter rejection reason">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rejectClaimDialog = false">Cancel</el-button>
        <el-button type="danger" @click="confirmRejectClaim" :loading="rejectClaimLoading">Reject</el-button>
      </div>
    </el-dialog>

    <!-- 单个下发对话框 -->
    <el-dialog title="Distribute Inventory" :visible.sync="singleDistributeDialog" width="600px">
      <div style="margin-bottom: 20px;">
        <h4>Claim Information</h4>
        <div v-if="singleDistributeClaim" style="background: #f5f7fa; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
          <p><strong>Tracking:</strong> {{singleDistributeClaim.tracking}}</p>
          <p><strong>UPC:</strong> {{singleDistributeClaim.upc}}</p>
          <p><strong>Quantity:</strong> {{singleDistributeClaim.claimedQty}}</p>
          <p><strong>Claimer:</strong> {{singleDistributeClaim.claimerName}} ({{singleDistributeClaim.claimerTypeDesc}})</p>
          <p><strong>Current Charge Time:</strong>
            <span v-if="singleDistributeClaim.forceChargeTime" class="charge-time-forced">
              {{formatDate(singleDistributeClaim.forceChargeTime)}}
            </span>
            <span v-else class="charge-time-normal">Normal Period</span>
          </p>
        </div>
      </div>

      <div style="margin-bottom: 20px;">
        <h4>Charge Strategy Setting</h4>
        <el-radio-group v-model="singleDistributeForm.chargeTimeOption">
          <div style="margin-bottom: 10px;">
            <el-radio label="normal">Use normal free period (Product > User > Default 3 months)</el-radio>
          </div>
          <div style="margin-bottom: 10px;">
            <el-radio label="immediate">Start charging immediately</el-radio>
          </div>
          <div style="margin-bottom: 10px;">
            <el-radio label="custom">Custom charge start time</el-radio>
          </div>
        </el-radio-group>

        <div v-if="singleDistributeForm.chargeTimeOption === 'custom'" style="margin-top: 15px;">
          <el-date-picker
            v-model="singleDistributeForm.customChargeTime"
            type="datetime"
            placeholder="Select charge start time"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 250px;">
          </el-date-picker>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="singleDistributeDialog = false">Cancel</el-button>
        <el-button
          type="primary"
          @click="confirmSingleDistribute"
          :loading="singleDistributeLoading">
          Confirm Distribute
        </el-button>
      </div>
    </el-dialog>

    <!-- 批量下发对话框 -->
    <el-dialog title="Batch Distribute Inventory" :visible.sync="batchDistributeDialog" width="900px">
      <div style="margin-bottom: 20px;">
        <h4>Selected Claims ({{selectedClaims.length}} items)</h4>
        <el-table :data="selectedClaims" size="small" max-height="400" style="width: 100%;">
          <el-table-column prop="tracking" label="Tracking #" min-width="140"></el-table-column>
          <el-table-column prop="upc" label="UPC" min-width="140"></el-table-column>
          <el-table-column prop="claimedQty" label="Qty" width="60" align="center"></el-table-column>
          <el-table-column prop="claimerName" label="Claimer" min-width="100"></el-table-column>
          <el-table-column label="Current Charge Time" min-width="200">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.editableChargeTime"
                type="datetime"
                placeholder="Select charge time"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="mini"
                style="width: 100%;"
                clearable>
              </el-date-picker>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-bottom: 20px;">
        <h4>Batch Charge Time Setting</h4>
        <el-alert
          title="Select a batch setting option and click Apply to quickly fill all Current Charge Time values in the table above. You can then adjust individual values before confirming."
          type="info"
          :closable="false"
          style="margin-bottom: 15px;">
        </el-alert>
        <div style="display: flex; align-items: flex-start; gap: 20px;">
          <div style="flex: 1;">
            <el-radio-group v-model="batchDistributeForm.chargeTimeOption" style="display: flex; flex-direction: column; gap: 8px;">
              <el-radio label="normal">Use normal free period (Product > User > Default 3 months)</el-radio>
              <el-radio label="immediate">Start charging immediately</el-radio>
              <el-radio label="custom">Custom charge start time</el-radio>
            </el-radio-group>

            <div v-if="batchDistributeForm.chargeTimeOption === 'custom'" style="margin-top: 15px;">
              <el-date-picker
                v-model="batchDistributeForm.customChargeTime"
                type="datetime"
                placeholder="Select charge start time"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 250px;">
              </el-date-picker>
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              :disabled="!batchDistributeForm.chargeTimeOption || (batchDistributeForm.chargeTimeOption === 'custom' && !batchDistributeForm.customChargeTime)"
              @click="applyBatchChargeTime">
              Apply to All
            </el-button>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDistributeDialog = false">Cancel</el-button>
        <el-button
          type="primary"
          @click="confirmBatchDistribute"
          :loading="batchDistributeLoading">
          Confirm Distribute
        </el-button>
      </div>
    </el-dialog>

    <!-- 设置强制收费时间对话框 -->
    <el-dialog title="Set Force Charge Time" :visible.sync="setChargeTimeDialog" width="900px">
      <div style="margin-bottom: 20px;">
        <h4>Editable Claims ({{editableClaimIds.length}} items)</h4>
        <el-alert
          title="Note: Only approved and quantity-adjusted claims can have their charge time modified before distribution."
          type="info"
          :closable="false"
          style="margin-bottom: 15px;">
        </el-alert>
        <el-table :data="editableClaims" size="small" max-height="400" style="width: 100%;">
          <el-table-column prop="tracking" label="Tracking #" min-width="140"></el-table-column>
          <el-table-column prop="upc" label="UPC" min-width="140"></el-table-column>
          <el-table-column prop="claimedQty" label="Qty" width="60" align="center"></el-table-column>
          <el-table-column prop="claimerName" label="Claimer" min-width="100"></el-table-column>
          <el-table-column label="Current Charge Time" min-width="200">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.editableChargeTime"
                type="datetime"
                placeholder="Select charge time"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="mini"
                style="width: 100%;"
                clearable>
              </el-date-picker>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-bottom: 20px;">
        <h4>Batch Charge Time Setting</h4>
        <el-alert
          title="Select a batch setting option and click Apply to quickly fill all Current Charge Time values in the table above. You can then adjust individual values before confirming."
          type="info"
          :closable="false"
          style="margin-bottom: 15px;">
        </el-alert>
        <div style="display: flex; align-items: flex-start; gap: 20px;">
          <div style="flex: 1;">
            <el-radio-group v-model="setChargeTimeForm.chargeTimeOption" style="display: flex; flex-direction: column; gap: 8px;">
              <el-radio label="normal">Restore to normal free period</el-radio>
              <el-radio label="immediate">Start charging immediately</el-radio>
              <el-radio label="custom">Set custom charge start time</el-radio>
            </el-radio-group>

            <div v-if="setChargeTimeForm.chargeTimeOption === 'custom'" style="margin-top: 15px;">
              <el-date-picker
                v-model="setChargeTimeForm.customChargeTime"
                type="datetime"
                placeholder="Select charge start time"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 250px;">
              </el-date-picker>
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              :disabled="!setChargeTimeForm.chargeTimeOption || (setChargeTimeForm.chargeTimeOption === 'custom' && !setChargeTimeForm.customChargeTime)"
              @click="applyBatchChargeTimeSetting">
              Apply to All
            </el-button>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="setChargeTimeDialog = false">Cancel</el-button>
        <el-button
          type="primary"
          @click="confirmSetChargeTime"
          :loading="setChargeTimeLoading">
          Confirm Setting
        </el-button>
      </div>
    </el-dialog>

    <!-- 认领详情对话框 -->
    <el-dialog title="Claim Detail" :visible.sync="claimDetailDialog" width="80%" @close="onClaimDetailClose">
      <div v-if="claimDetail">
        <el-descriptions title="Claim Information" :column="3" border class="claim-detail-descriptions">
          <el-descriptions-item label="Tracking #" label-class-name="claim-label">{{claimDetail.tracking}}</el-descriptions-item>
          <el-descriptions-item label="UPC" label-class-name="claim-label">{{claimDetail.upc}}</el-descriptions-item>
          <el-descriptions-item label="Claimer" label-class-name="claim-label">
            <div>
              <p><strong>{{claimDetail.claimerName}}</strong></p>
              <el-tag size="mini" :type="claimDetail.claimerType === 1 ? 'success' : 'info'">
                {{claimDetail.claimerTypeDesc}}
              </el-tag>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="Product Name" :span="3" label-class-name="claim-label">
            <div v-if="claimDetail.productName" class="product-name-container">
              <el-tooltip :content="claimDetail.productName" placement="top-start">
                <span class="product-name-text">{{claimDetail.productName}}</span>
              </el-tooltip>
            </div>
            <span v-else class="note">N/A</span>
          </el-descriptions-item>
          <el-descriptions-item label="Claimed Qty" label-class-name="claim-label">{{claimDetail.claimedQty}}</el-descriptions-item>
          <el-descriptions-item label="Total Available" label-class-name="claim-label">{{claimDetail.totalQty}}</el-descriptions-item>
          <el-descriptions-item label="Unclaimed Qty" label-class-name="claim-label">{{claimDetail.unclaimedQty}}</el-descriptions-item>
          <el-descriptions-item label="Claim Date" label-class-name="claim-label">{{formatDate(claimDetail.claimDate)}}</el-descriptions-item>
          <el-descriptions-item label="Status" label-class-name="claim-label">
            <el-tag :type="getClaimStatusTagType(claimDetail.claimStatus)">
              {{getClaimStatusText(claimDetail.claimStatus)}}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="Charge Time" label-class-name="claim-label">
            <div v-if="claimDetail.forceChargeTime" class="charge-time-forced">
              <i class="el-icon-time"></i>
              Force: {{formatDate(claimDetail.forceChargeTime)}}
            </div>
            <div v-else class="charge-time-normal">
              <i class="el-icon-clock"></i>
              Normal Period
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="Review Date" label-class-name="claim-label">
            <span v-if="claimDetail.reviewDate">{{formatDate(claimDetail.reviewDate)}}</span>
            <span v-else class="note">Not reviewed yet</span>
          </el-descriptions-item>
          <el-descriptions-item label="Reviewed By" label-class-name="claim-label">
            <span v-if="claimDetail.reviewByName">{{claimDetail.reviewByName}}</span>
            <span v-else class="note">N/A</span>
          </el-descriptions-item>
          <el-descriptions-item label="Distribute Date" label-class-name="claim-label">
            <span v-if="claimDetail.distributeDate">{{formatDate(claimDetail.distributeDate)}}</span>
            <span v-else class="note">Not distributed yet</span>
          </el-descriptions-item>
          <el-descriptions-item label="Review Note" :span="3" label-class-name="claim-label">
            <p v-if="claimDetail.reviewReason">{{claimDetail.reviewReason}}</p>
            <span v-else class="note">No review note</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-else style="text-align: center; padding: 40px;">
        <p style="color: #909399; font-size: 14px;">No claim detail data available</p>
      </div>
    </el-dialog>

    <!-- Batch Bulk Reverse Dialog -->
    <el-dialog
      title="Bulk Reverse by Batch"
      width="80%"
      :visible.sync="batchBulkReverseDialogVisible"
      :close-on-click-modal="false">

      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true">
          <el-form-item style="float: right" label="Batch Number:">
            <el-select
              placeholder="Select a batch number"
              @change="changeBatchNumberForBulkReverse"
              v-model="selectedBatchNumber"
              clearable
              filterable
              style="width: 300px;">
              <el-option
                v-for="(batch, index) in availableBatchNumbers"
                :value="batch"
                :label="batch"
                :key="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>

      <el-table
        stripe
        :data="batchPackagesList"
        highlight-current-row
        v-loading="batchPackagesLoading"
        style="width: 100%;">
        <el-table-column type="index" width="60"></el-table-column>
        <el-table-column prop="tracking" label="Tracking #" min-width="180"></el-table-column>
        <el-table-column prop="warehouse" label="Warehouse" min-width="150"></el-table-column>
        <el-table-column label="Items Status" min-width="180">
          <template slot-scope="scope">
            <p>Total: {{scope.row.totalItems}} items</p>
            <p>Claimed: {{scope.row.claimedItems}} items</p>
            <p>Remaining: {{scope.row.unclaimedItems}} items</p>
          </template>
        </el-table-column>
        <el-table-column label="Package Status" min-width="120">
          <template slot-scope="scope">
            <el-tag
              :type="getStatusTagType(scope.row.packageStatus)"
              size="small">
              {{getStatusText(scope.row.packageStatus)}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="Create Date" min-width="180">
          <template slot-scope="scope">
            <p>{{formatDate(scope.row.createDate)}}</p>
            <p class="note">by {{scope.row.createUserName}}</p>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchBulkReverseDialogVisible = false">Cancel</el-button>
        <el-button
          type="danger"
          @click="executeBatchBulkReverse"
          :loading="batchBulkReverseLoading"
          :disabled="!selectedBatchNumber || batchPackagesList.length === 0">
          Bulk Reverse ({{batchPackagesList.length}} packages)
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑混寄包裹UPC数量对话框 -->
    <el-dialog
      title="Edit UPC Quantity in Mixed Package"
      :visible.sync="editMixedPackageUPCQtyDialog"
      width="500px"
      :close-on-click-modal="false">
      <el-form :model="editMixedPackageUPCQtyForm" :rules="editMixedPackageUPCQtyRules" ref="editMixedPackageUPCQtyForm" label-width="140px">
        <el-form-item label="UPC">
          <span>{{ editMixedPackageUPCQtyForm.upc }}</span>
        </el-form-item>
        <el-form-item label="Product Name">
          <span>{{ editMixedPackageUPCQtyForm.productName || 'N/A' }}</span>
        </el-form-item>
        <el-form-item label="Current Total Qty">
          <span>{{ editMixedPackageUPCQtyForm.currentTotalQty }}</span>
        </el-form-item>
        <el-form-item label="Claimed Qty">
          <span>{{ editMixedPackageUPCQtyForm.claimedQty }}</span>
        </el-form-item>
        <el-form-item label="New Total Qty" prop="newTotalQty">
          <el-input-number
            v-model="editMixedPackageUPCQtyForm.newTotalQty"
            :min="editMixedPackageUPCQtyForm.claimedQty"
            :max="99999"
            placeholder="Enter new total quantity"
            style="width: 100%;">
          </el-input-number>
          <p style="margin-top: 5px; color: #909399; font-size: 12px;">
            Note: New total quantity cannot be less than claimed quantity ({{ editMixedPackageUPCQtyForm.claimedQty }})
          </p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editMixedPackageUPCQtyDialog = false">Cancel</el-button>
        <el-button type="primary" @click="confirmEditMixedPackageUPCQty" :loading="editingMixedPackageUPCQty">
          Confirm
        </el-button>
      </div>
    </el-dialog>

    <!-- Import Result Dialog -->
    <ImportResultDialog
      :visible.sync="importResultDialogVisible"
      :result="importResultData"
      @continue="handleImportContinue"
      @retry-failed="handleRetryFailed"
      @close="handleImportResultClose" />

    <!-- Bulk Confirm Result Dialog -->
    <BulkConfirmResultDialog
      :visible.sync="bulkConfirmResultDialogVisible"
      :result="bulkConfirmResultData"
      @continue="handleBulkConfirmContinue"
      @retry-failed="handleBulkConfirmRetryFailed"
      @close="handleBulkConfirmResultClose" />

  </section>
</template>

<script>
import { mixedPackageApi } from '@/api/mixedPackage'
import { getWarehouseForWarehouseAdmin } from '@/api/warehouseService'
import { getBatchNumber } from '@/api/inboundService'
import { serverUrl } from '@/globalVar'
import { postExportExcel } from '@/api/exportService'
import ImportResultDialog from '@/components/ImportResultDialog.vue'
import BulkConfirmResultDialog from '@/components/BulkConfirmResultDialog.vue'

export default {
  name: 'MixedPackageList',
  components: {
    ImportResultDialog,
    BulkConfirmResultDialog
  },
  data() {
    return {
      activeName: 'toConfirm',
      pageSize: 20,

      // 过滤条件
      filters: {
        batchFilter: '',
        trackingFilter: '',
        packageFilter: '',
        packageStatus: '',
        claimFilter: '',
        claimStatus: '',
        unclaimedFilter: '',
        dateRange: []
      },

      // 可用的批次号列表
      availableBatches: [],
      availableBatchesLoading: false,

      // 包裹管理相关筛选条件
      packageFilters: {
        batchNumber: '',
        tracking: '',
        upc: '',
        packageStatus: null,
        warehouseNo: null
      },

      // 混寄包裹批次列表(用于筛选)
      mixedPackageBatches: [],
      mixedPackageBatchesLoading: false,
      mixedPackageBatchSearchTimer: null, // 搜索防抖定时器

      // 待确认批次搜索防抖定时器
      pendingBatchSearchTimer: null,

      // 认领管理相关筛选条件
      claimFilters: {
        batchNumber: null,
        tracking: '',
        upc: '',
        warehouseNo: null,
        claimStatus: null
      },
      claimCurrentPage: 1,
      claimSize: 20,
      pendingClaimsCount: 0,

      // Claims Review批次列表(用于筛选)
      claimsBatches: [],
      claimsBatchesLoading: false,
      claimsBatchSearchTimer: null,

      // 分页参数
      packageCurrentPage: 1,
      packageSize: 20,

      // 仓库列表（用于Mixed Packages Tab等）
      warehouses: [],

      // Claims Review Tab专用仓库列表（显示所有管理的仓库）
      claimWarehouses: [],

      // 创建包裹对话框
      createPackageDialog: false,
      createPackageLoading: false,
      createPackageForm: {
        tracking: '',
        warehouseNo: null,
        items: [{ upc: '', qty: 1 }]
      },
      createPackageRules: {
        tracking: [
          { required: true, message: 'Please enter tracking number', trigger: 'blur' },
          { min: 12, message: 'Tracking number must be at least 12 digits', trigger: 'blur' },
          { max: 34, message: 'Tracking number cannot exceed 34 digits', trigger: 'blur' }
        ],
        warehouseNo: [{ required: true, message: 'Please select warehouse', trigger: 'change' }]
      },

      // Tab 1: 待确认包裹 (按批次号 + Tracking维度)
      pendingPackageList: [],
      pendingBatchLoading: false,
      pendingBatchTotal: 0,
      currentPendingBatchPage: 1,
      selectedPackages: [],

      // Tab 2: 混寄包裹
      packageList: [],
      packageLoading: false,
      packageTotal: 0,
      currentPackagePage: 1,
      selectedPackages: [],

      // Tab 3: 认领审核
      claimList: [],
      claimLoading: false,
      claimTotal: 0,
      selectedClaims: [],
      currentClaimPage: 1,

      // Tab 4: 未认领商品
      unclaimedList: [],
      unclaimedLoading: false,
      unclaimedTotal: 0,
      currentUnclaimedPage: 1,

      // 未认领商品筛选条件和分页
      unclaimedFilters: {
        upc: ''
      },
      unclaimedCurrentPage: 1,
      unclaimedSize: 20,

      // 包裹详情对话框
      packageDetailDialogVisible: false,
      packageDetailLoading: false,
      currentPackageDetail: null,

      // 批量导入对话框
      batchImportDialogVisible: false,
      importing: false,
      importForm: {
        batchNumber: '',
        warehouseNo: '',
        importMethod: 'text',
        textContent: '',
        excelFile: null
      },
      importRules: {
        warehouseNo: [
          { required: true, message: 'Please select a warehouse', trigger: 'change' }
        ],
        textContent: [
          { required: true, message: 'Please enter package data', trigger: 'blur' }
        ]
      },
      excelFileList: [],
      warehouses: [],

      // Excel上传配置 (使用el-upload action方式，参考Inbound实现)
      excelUploadUrl: '',
      uploadHeaders: {},
      excelUploadData: {},

      // Import Result Dialog
      importResultDialogVisible: false,
      importResultData: {
        totalCount: 0,
        successCount: 0,
        failedCount: 0,
        successTrackings: [],
        successDetails: null,
        failedRecords: []
      },

      // Bulk Confirm Result Dialog
      bulkConfirmResultDialogVisible: false,
      bulkConfirmResultData: {
        totalPackages: 0,
        successCount: 0,
        failedCount: 0,
        createdPackageIds: [],
        failureRecords: [],
        batchNumber: ''
      },

      // 包裹详情对话框 (显示UPC维度)
      batchDetailDialogVisible: false,
      batchDetailLoading: false,
      currentPackageDetail: null,
      selectedUPCs: [], // 选中的UPC列表

      // 批量确认对话框
      bulkConfirmDialogVisible: false,
      bulkConfirming: false,

      // 认领审核相关对话框
      batchApproveDialogVisible: false,
      batchApproving: false,

      batchDistributeDialogVisible: false,
      batchDistributing: false,

      adjustClaimDialogVisible: false,
      adjusting: false,
      currentClaimForAdjust: null,
      adjustForm: {
        newQuantity: 1,
        adjustReason: ''
      },
      adjustRules: {
        newQuantity: [
          { required: true, message: 'Please enter new quantity', trigger: 'blur' }
        ],
        adjustReason: [
          { required: true, message: 'Please enter adjustment reason', trigger: 'blur' }
        ]
      },

      rejectClaimDialogVisible: false,
      rejecting: false,
      currentClaimForReject: null,
      rejectForm: {
        rejectReason: ''
      },
      rejectRules: {
        rejectReason: [
          { required: true, message: 'Please enter reject reason', trigger: 'blur' }
        ]
      },

      forceChargeTimeDialogVisible: false,
      settingForceCharge: false,
      forceChargeForm: {
        forceChargeTime: '',
        reason: ''
      },
      forceChargeRules: {
        forceChargeTime: [
          { required: true, message: 'Please select force charge time', trigger: 'change' }
        ],
        reason: [
          { required: true, message: 'Please enter reason', trigger: 'blur' }
        ]
      },

      // 调整数量对话框
      adjustQuantityDialog: false,
      adjustQuantityLoading: false,
      adjustQuantityForm: {
        claimId: null,
        originalQty: 0,
        newQuantity: 0,
        maxQty: 0,
        reason: ''
      },
      adjustQuantityRules: {
        newQuantity: [{ required: true, message: 'Please enter new quantity', trigger: 'blur' }]
      },

      // 拒绝认领对话框
      rejectClaimDialog: false,
      rejectClaimLoading: false,
      rejectClaimForm: {
        claimId: null,
        reason: ''
      },
      rejectClaimRules: {
        reason: [{ required: true, message: 'Please enter rejection reason', trigger: 'blur' }]
      },

      // 批量下发对话框
      batchDistributeDialog: false,
      batchDistributeLoading: false,
      batchDistributeForm: {
        chargeTimeOption: 'normal',
        customChargeTime: null
      },

      // 单个下发对话框
      singleDistributeDialog: false,
      singleDistributeLoading: false,
      singleDistributeClaim: null,
      singleDistributeForm: {
        chargeTimeOption: 'normal',
        customChargeTime: null
      },

      // 设置收费时间对话框
      setChargeTimeDialog: false,
      setChargeTimeLoading: false,
      setChargeTimeForm: {
        chargeTimeOption: 'normal',
        customChargeTime: null
      },

      // 认领详情对话框
      claimDetailDialog: false,
      claimDetail: null,

      // 编辑UPC相关
      editUPCDialog: false,
      savingUPCEdit: false,
      editUPCForm: {
        upc: '',
        quantity: 1,
        originalUpc: '',
        originalQuantity: 1
      },
      editUPCRules: {
        upc: [
          { required: true, message: 'UPC code is required', trigger: 'blur' },
          { min: 1, max: 50, message: 'UPC code must be 1-50 characters', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: 'Quantity is required', trigger: 'blur' },
          { type: 'number', min: 1, max: 9999, message: 'Quantity must be between 1 and 9999', trigger: 'blur' }
        ]
      },
      editingUPCIndex: -1,

      // 批次批量撤销对话框
      batchBulkReverseDialogVisible: false,
      batchBulkReverseLoading: false,
      selectedBatchNumber: '',
      availableBatchNumbers: [],
      batchPackagesList: [],
      batchPackagesLoading: false,

      // 编辑混寄包裹UPC数量对话框
      editMixedPackageUPCQtyDialog: false,
      editingMixedPackageUPCQty: false,
      editMixedPackageUPCQtyForm: {
        detailId: null,
        mixedPackageId: null,
        upc: '',
        productName: '',
        currentTotalQty: 0,
        claimedQty: 0,
        newTotalQty: 0,
        reason: ''
      },
      editMixedPackageUPCQtyRules: {
        newTotalQty: [
          { required: true, message: 'Please enter new total quantity', trigger: 'blur' },
          { type: 'number', min: 0, message: 'Quantity cannot be negative', trigger: 'blur' }
        ]
      },

      // 定时器
      timer: null
    }
  },

  computed: {
    // To Confirm Tab 动态页面大小
    dynamicPendingPageSize() {
      // 有批次号过滤时（非空字符串）显示50条，否则使用用户选择的页面大小
      return (this.filters.batchFilter && this.filters.batchFilter.trim() !== '') ? 50 : this.pageSize
    }
  },

  mounted() {
    this.getPendingPackages()
    this.getAvailableBatches()
    this.getWarehouseList()
    this.loadClaimWarehouses()  // 加载Claims Review Tab的仓库列表
    this.refreshPendingCount()

    // 定时刷新待审核数量 - 每2分钟刷新一次
    this.timer = setInterval(() => {
      this.refreshPendingCount()
    }, 120000)
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    // 清理搜索防抖定时器
    if (this.mixedPackageBatchSearchTimer) {
      clearTimeout(this.mixedPackageBatchSearchTimer)
    }
    if (this.pendingBatchSearchTimer) {
      clearTimeout(this.pendingBatchSearchTimer)
    }
  },

  watch: {
    activeName(newTab) {
      switch(newTab) {
        case 'toConfirm':
          this.getPendingPackages()
          break
        case 'packages':
          this.getMixedPackageList()
          break
        case 'claims':
          this.getClaimList()
          this.refreshPendingCount()
          break
        case 'unclaimed':
          this.getUnclaimedItems()
          break
      }
    }
  },

  methods: {
    // ==================== Tab 1: 待确认包裹 (按批次号 + Tracking维度) ====================
    async getPendingPackages() {
      this.pendingBatchLoading = true
      try {
        const params = {
          current: this.currentPendingBatchPage,
          size: this.dynamicPendingPageSize || 50, // 默认50条，避免size为0
          batchNumber: this.filters.batchFilter || null, // 空字符串转为null
          tracking: this.filters.trackingFilter || null
        }

        // 需要调用获取包裹详情的API，而不是批次汇总API
        const response = await mixedPackageApi.getPendingPackages(params)

        if (response && (response.code === 200 || response.code === '200')) {
          const rawRecords = response.result.records || []

          // Transform data for package-level display (Batch + Tracking dimension)
          this.pendingPackageList = rawRecords.map(record => {
            // Try to get the import date from various possible field names
            let importDate = record.importDate || record.import_date || record.createTime || record.create_time || record.createdDate || record.created_date || ''

            // Format the date if it exists
            if (importDate) {
              try {
                // Handle different date formats
                if (typeof importDate === 'string' && importDate.includes('T')) {
                  // ISO format: 2024-01-01T10:30:00.000Z
                  importDate = this.formatDate(new Date(importDate))
                } else if (typeof importDate === 'number') {
                  // Timestamp format
                  importDate = this.formatDate(new Date(importDate))
                } else if (importDate instanceof Date) {
                  importDate = this.formatDate(importDate)
                } else {
                  // String format, try to parse
                  importDate = this.formatDate(new Date(importDate))
                }
              } catch (error) {
                importDate = importDate.toString()
              }
            }

            const transformed = {
              id: record.id || record.recordId || '',
              batchNumber: record.batchNumber || record.batch_number || record.batchNo || '',
              tracking: record.tracking || record.trackingNumber || '',
              itemCount: record.itemCount || record.item_count || record.itemNum || 0,
              warehouseName: record.warehouseName || record.warehouse_name || record.warehouse || '',
              importDate: importDate,
              status: record.status || 'pending',
              note: record.note || record.description || '',
              items: record.items || [] // UPC详情列表，用于Detail对话框
            }
            return transformed
          })

          this.pendingBatchTotal = response.result.total || 0
        } else {
          this.$message.error(response.msg || 'Failed to load pending packages')
        }
      } catch (error) {
        this.$message.error('Error loading pending packages: ' + error.message)
      } finally {
        this.pendingBatchLoading = false
      }
    },

    // 获取可用的批次号列表 - 只获取最近50个
    async getAvailableBatches(searchKeyword = '') {
      this.availableBatchesLoading = true
      try {
        // 只获取最近50个待确认批次
        const params = {
          current: 1,
          size: 50, // 只加载最近50个批次
          keyword: searchKeyword // 搜索关键词
        }

        const response = await mixedPackageApi.getPendingBatches(params)

        if (response && (response.code === 200 || response.code === '200')) {
          let batches = response.result.records || []

          // 转换为简单的批次号数组，不再显示统计信息
          // 后端SQL已按 import_date DESC 排序，保持原有顺序即可
          this.availableBatches = batches.map(batch => ({
            batchNumber: batch.batchNumber || batch.batch_number
          }))
        } else {
          console.error('Failed to load available batches:', response.msg)
          this.availableBatches = []
        }
      } catch (error) {
        console.error('Error loading available batches:', error.message)
        this.availableBatches = []
      } finally {
        this.availableBatchesLoading = false
      }
    },

    // 远程搜索待确认批次号(带防抖和最少字符限制)
    searchPendingBatchNumbers(query) {
      // 清除之前的定时器
      if (this.pendingBatchSearchTimer) {
        clearTimeout(this.pendingBatchSearchTimer)
      }

      // 如果清空搜索，立即加载默认批次
      if (query === '' || query === null || query === undefined) {
        this.getAvailableBatches('')
        return
      }

      // 如果输入少于2个字符，不触发搜索
      if (query.length < 2) {
        return
      }

      // 300ms防抖延迟
      this.pendingBatchSearchTimer = setTimeout(() => {
        this.getAvailableBatches(query)
      }, 300)
    },

    // 处理待确认批次下拉框显示/隐藏
    handlePendingBatchDropdownVisible(visible) {
      if (visible && this.availableBatches.length === 0) {
        // 下拉框打开时,如果还没有加载批次列表,则加载最近50条
        this.getAvailableBatches('')
      }
    },

    // 处理待确认批次号选择变化
    handlePendingBatchNumberChange(value) {
      console.log('Pending batch number changed:', value)
      // 重置到第一页
      this.currentPendingBatchPage = 1
      // 触发查询
      this.getPendingPackages()
    },

    // 处理待确认批次号清除
    handlePendingBatchNumberClear() {
      console.log('Pending batch number cleared')
      // 重置到第一页
      this.currentPendingBatchPage = 1
      // 触发查询
      this.getPendingPackages()
    },

    changePendingBatchPage(page) {
      this.currentPendingBatchPage = page
      this.getPendingPackages()
    },

    handlePendingBatchSizeChange(val) {
      this.pageSize = val
      this.currentPendingBatchPage = 1
      this.getPendingPackages()
    },

    handlePackageSelection(selection) {
      this.selectedPackages = selection
    },

    getBatchStatusType(status) {
      const statusMap = {
        'pending': '',
        'processing': 'warning',
        'confirmed': 'success',
        'failed': 'danger'
      }
      return statusMap[status] || ''
    },

    // ==================== Tab 2: 混寄包裹 ====================
    async getMixedPackageList() {
      this.packageLoading = true
      try {
        const params = {
          current: this.packageCurrentPage,
          size: this.packageSize,
          ...this.packageFilters
        }

        const response = await mixedPackageApi.getMixedPackageList(params)
        if (response && (response.code === 200 || response.code === '200')) {
          this.packageList = response.result.records || (response.data && response.data.records) || []
          this.packageTotal = response.result.total || (response.data && response.data.total) || 0
        } else {
          this.$message.error(response.msg || 'Failed to load packages')
        }
      } catch (error) {
        this.$message.error('Error loading packages: ' + error.message)
      } finally {
        this.packageLoading = false
      }
    },

    // 获取混寄包裹批次列表(用于筛选) - 只获取最近的批次
    async getMixedPackageBatches(searchKeyword = '') {
      this.mixedPackageBatchesLoading = true
      try {
        const params = {
          current: 1,
          size: 50, // 只加载最近50个批次
          keyword: searchKeyword // 搜索关键词
        }

        const response = await mixedPackageApi.getBatchNumbers(params)

        if (response && (response.code === 200 || response.code === '200')) {
          const resultData = response.result || {}

          // 后端返回格式: { batchNumbers: [], total: 0, current: 1, size: 50 }
          let batchNumbers = resultData.batchNumbers || []

          // 兼容旧格式:如果直接返回数组
          if (Array.isArray(response.result)) {
            batchNumbers = response.result
          }

          // 转换为组件需要的格式
          this.mixedPackageBatches = batchNumbers.map(batchNumber => ({
            batchNumber: batchNumber
          }))

        } else {
          console.error('Failed to load mixed package batches:', response.msg)
          this.mixedPackageBatches = []
        }
      } catch (error) {
        console.error('Error loading mixed package batches:', error.message)
        this.mixedPackageBatches = []
      } finally {
        this.mixedPackageBatchesLoading = false
      }
    },

    // 远程搜索批次号(带防抖和最少字符限制)
    searchBatchNumbers(query) {
      // 清除之前的定时器
      if (this.mixedPackageBatchSearchTimer) {
        clearTimeout(this.mixedPackageBatchSearchTimer)
      }

      // 如果清空搜索，立即加载默认批次
      if (query === '' || query === null || query === undefined) {
        this.getMixedPackageBatches('')
        return
      }

      // 如果输入少于2个字符，不触发搜索
      if (query.length < 2) {
        return
      }

      // 300ms防抖延迟
      this.mixedPackageBatchSearchTimer = setTimeout(() => {
        this.getMixedPackageBatches(query)
      }, 300)
    },

    // 处理批次下拉框显示/隐藏
    handleBatchDropdownVisible(visible) {
      if (visible && this.mixedPackageBatches.length === 0) {
        // 下拉框打开时,如果还没有加载批次列表,则加载最近50条
        this.getMixedPackageBatches('')
      }
    },

    // 处理批次号选择变化
    handleBatchNumberChange(value) {
      console.log('Batch number changed:', value)
      // 重置到第一页
      this.packageCurrentPage = 1
      // 触发查询
      this.getMixedPackageList()
    },

    // 处理批次号清除
    handleBatchNumberClear() {
      console.log('Batch number cleared')
      // 重置到第一页
      this.packageCurrentPage = 1
      // 触发查询
      this.getMixedPackageList()
    },

    handlePackageSizeChange(val) {
      this.packageSize = val
      this.getMixedPackageList()
    },

    handlePackageCurrentChange(val) {
      this.packageCurrentPage = val
      this.getMixedPackageList()
    },

    changePackagePage(page) {
      this.currentPackagePage = page
      this.getMixedPackageList()
    },

    exportMixedPackages() {
      const param = {
        url: '/excel/exportMixedPackages',
        fileName: 'MixedPackages.xls',
        doctorNo: window.sessionStorage.getItem('currentCompany'),
        batchNumber: this.packageFilters.batchNumber,
        tracking: this.packageFilters.tracking,
        upc: this.packageFilters.upc,
        packageStatus: this.packageFilters.packageStatus,
        warehouseNo: this.packageFilters.warehouseNo
      }
      postExportExcel(param).then(() => {
        // 导出成功
      })
    },

    handlePackageSelection(selection) {
      this.selectedPackages = selection
    },

    getPackageStatusType(status) {
      const statusMap = {
        'active': 'success',
        'cancelled': 'danger',
        'pending': 'warning',
        0: '',
        1: 'warning',
        2: 'success',
        3: 'info'
      }
      return statusMap[status] || ''
    },

    // ==================== Tab 3: 认领审核 ====================
    getClaimList() {
      this.claimLoading = true
      const params = {
        current: this.claimCurrentPage,
        size: this.claimSize,
        ...this.claimFilters
      }

      return mixedPackageApi.getClaimListForReview(params).then(res => {
        if (res.code === 200 || res.code === '200') {
          this.claimList = res.result.records || (res.data && res.data.records) || []
          this.claimTotal = res.result.total || (res.data && res.data.total) || 0
        } else {
          this.$message.error(res.message || 'Failed to load claims')
        }
        this.claimLoading = false
        return res // 返回结果供链式调用
      }).catch(err => {
        // 使用全局错误处理方法
        if (!this.handleApiError(err)) {
          this.$message.error('Error loading claims: ' + (err.message || 'Unknown error'))
        }
        this.claimLoading = false
        throw err // 重新抛出错误供链式调用处理
      })
    },

    exportClaimList() {
      const param = {
        url: '/excel/exportMixedPackageClaims',
        fileName: 'ClaimsReview.xls',
        ...this.claimFilters
      }
      postExportExcel(param).then(() => {
        this.$message.success('Export completed successfully')
      }).catch(err => {
        this.$message.error('Export failed: ' + (err.message || 'Unknown error'))
      })
    },

    handleClaimSizeChange(val) {
      this.claimSize = val
      this.getClaimList()
    },

    handleClaimCurrentChange(val) {
      this.claimCurrentPage = val
      this.getClaimList()
    },

    handleClaimSelectionChange(selection) {
      this.selectedClaims = selection
    },

    changeClaimPage(page) {
      this.claimCurrentPage = page
      this.getClaimList()
    },

    getClaimStatusType(status) {
      const statusMap = {
        0: 'warning',  // 待审核
        1: 'primary',  // 已批准
        2: 'success',  // 已下放
        3: 'danger',   // 已拒绝
        4: 'info',     // 数量已调整
        5: 'info'      // 已取消
      }
      return statusMap[status] || ''
    },

    // 获取Claims Review批次号列表(带搜索参数) - 与Mixed Packages Tab使用相同的过滤条件
    async getClaimsBatches(searchKeyword = '') {
      this.claimsBatchesLoading = true
      try {
        const params = {
          current: 1,
          size: 50, // 只加载最近50个批次
          keyword: searchKeyword // 搜索关键词
        }

        const response = await mixedPackageApi.getBatchNumbers(params)

        if (response && (response.code === 200 || response.code === '200')) {
          const resultData = response.result || {}

          // 后端返回格式: { batchNumbers: [], total: 0, current: 1, size: 50 }
          let batchNumbers = resultData.batchNumbers || []

          // 兼容旧格式:如果直接返回数组
          if (Array.isArray(response.result)) {
            batchNumbers = response.result
          }

          // 转换为组件需要的格式
          this.claimsBatches = batchNumbers.map(batchNumber => ({
            batchNumber: batchNumber
          }))

        } else {
          console.error('Failed to load claims batches:', response.msg)
          this.claimsBatches = []
        }
      } catch (error) {
        console.error('Error loading claims batches:', error.message)
        this.claimsBatches = []
      } finally {
        this.claimsBatchesLoading = false
      }
    },

    // 远程搜索Claims批次号(带防抖和最少字符限制)
    searchClaimsBatchNumbers(query) {
      // 清除之前的定时器
      if (this.claimsBatchSearchTimer) {
        clearTimeout(this.claimsBatchSearchTimer)
      }

      // 如果清空搜索，立即加载默认批次
      if (query === '' || query === null || query === undefined) {
        this.getClaimsBatches('')
        return
      }

      // 如果输入少于2个字符，不触发搜索
      if (query.length < 2) {
        return
      }

      // 300ms防抖延迟
      this.claimsBatchSearchTimer = setTimeout(() => {
        this.getClaimsBatches(query)
      }, 300)
    },

    // 处理Claims批次下拉框显示/隐藏
    handleClaimsBatchDropdownVisible(visible) {
      if (visible && this.claimsBatches.length === 0) {
        // 下拉框打开时,如果还没有加载批次列表,则加载最近50条
        this.getClaimsBatches('')
      }
    },

    // 处理Claims批次号选择变化
    handleClaimsBatchNumberChange(value) {
      console.log('Claims batch number changed:', value)
      // 重置到第一页
      this.claimCurrentPage = 1
      // 触发查询
      this.getClaimList()
    },

    // 处理Claims批次号清除
    handleClaimsBatchNumberClear() {
      console.log('Claims batch number cleared')
      // 重置到第一页
      this.claimCurrentPage = 1
      // 触发查询
      this.getClaimList()
    },

    // ==================== Tab 4: 未认领商品 ====================
    async getUnclaimedItems() {
      this.unclaimedLoading = true
      try {
        const params = {
          current: this.unclaimedCurrentPage,
          size: this.unclaimedSize,
          ...this.unclaimedFilters
        }

        const response = await mixedPackageApi.getUnclaimedItems(params)
        if (response && (response.code === 200 || response.code === '200')) {
          this.unclaimedList = response.result.records || (response.data && response.data.records) || []
          this.unclaimedTotal = response.result.total || (response.data && response.data.total) || 0
        } else {
          this.$message.error(response.msg || 'Failed to load unclaimed items')
        }
      } catch (error) {
        this.$message.error('Error loading unclaimed items: ' + error.message)
      } finally {
        this.unclaimedLoading = false
      }
    },

    // 使用旧版本方法名保持兼容性
    async getUnclaimedItemsList() {
      await this.getUnclaimedItems()
    },

    changeUnclaimedPage(page) {
      this.unclaimedCurrentPage = page
      this.getUnclaimedItems()
    },

    handleUnclaimedSizeChange(val) {
      this.unclaimedSize = val
      this.getUnclaimedItems()
    },

    handleUnclaimedCurrentChange(val) {
      this.unclaimedCurrentPage = val
      this.getUnclaimedItems()
    },

    // ==================== 操作方法 ====================

    // 批量导入
    async showBatchImport() {
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: 'Preparing batch import...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 重置表单（不包括批次号）
        this.resetImportFormFields()

        // 生成批次号（使用与Inbound相同的API）
        const batchResponse = await getBatchNumber()
        if (batchResponse && batchResponse.status === 200) {
          this.importForm.batchNumber = batchResponse.result.batchNumber
        } else {
          this.$message.error('Failed to generate batch number: ' + (batchResponse.message || 'Unknown error'))
          return
        }

        // 加载仓库列表
        await this.loadWarehouses()

        // 初始化Excel上传配置（参考Inbound实现）
        this.initializeExcelUploadConfig()

        // 显示对话框
        this.batchImportDialogVisible = true
      } catch (error) {
        this.$message.error('Error opening import dialog: ' + error.message)
      } finally {
        loading.close()
      }
    },

    // 加载Claims Review Tab的仓库列表（显示所有管理的仓库）
    async loadClaimWarehouses() {
      try {
        // Claims Review Tab: 加载当前仓库管理员管理的所有仓库（不限于特定神医）
        // 不传入doctorNo参数，后端将返回admin_no匹配的所有仓库
        const response = await getWarehouseForWarehouseAdmin({})

        if (response.code === 200 || response.code === '200') {
          this.claimWarehouses = response.records || []
        } else {
          this.$message.error('Failed to load claim warehouses: ' + response.msg)
        }
      } catch (error) {
        this.$message.error('Failed to load claim warehouses: ' + error.message)
      }
    },

    // 加载仓库列表（用于Batch Import等功能）
    async loadWarehouses() {
      try {
        // 使用当前公司信息获取仓库列表
        const currentCompany = window.sessionStorage.getItem("currentCompany")
        const response = await getWarehouseForWarehouseAdmin({
          doctorNo: currentCompany
        })

        if (response.code === 200 || response.code === '200') {
          this.warehouses = response.records || []

          // 如果只有一个仓库，自动选择
          if (this.warehouses.length === 1) {
            this.importForm.warehouseNo = this.warehouses[0].warehouseNo
          }
        } else {
          this.$message.error('Failed to load warehouses: ' + response.msg)
        }
      } catch (error) {
        this.$message.error('Failed to load warehouses: ' + error.message)
      }
    },

    // 重置导入表单
    resetImportForm() {
      // 保留批次号，重置其他字段
      const currentBatchNumber = this.importForm.batchNumber
      this.resetImportFormFields()
      // 恢复批次号
      this.importForm.batchNumber = currentBatchNumber
    },

    // 重置导入表单字段（不包括批次号）
    resetImportFormFields() {
      this.importForm.warehouseNo = ''
      this.importForm.importMethod = 'text'
      this.importForm.textContent = ''
      this.importForm.excelFile = null
      this.excelFileList = []

      if (this.$refs.importForm) {
        this.$refs.importForm.clearValidate()
      }
    },

    // 关闭导入对话框
    closeBatchImportDialog() {
      this.batchImportDialogVisible = false
      this.resetImportForm()
    },

    // 解析文本数据以支持多种格式并清理空格
    parseTextData(textContent) {

      if (!textContent || !textContent.trim()) {
        return textContent
      }

      let text = textContent.trim()

      // 检查是否包含换行符
      if (!text.includes('\n')) {
        // 单行数据，尝试按空格或制表符分割
        const items = this.smartSplitSingleLine(text)
        if (items.length > 1) {
          text = items.join('\n')
        } else if (items.length === 1 && items[0] !== text.trim()) {
          // 单条数据，但可能需要清理格式
          text = items[0]
        }
      } else {
        // 多行格式，但每行可能包含多个包裹
        const lines = text.split('\n')
        const allProcessedLines = []

        for (const line of lines) {
          const trimmedLine = line.trim()
          if (!trimmedLine) continue

          // 检查这一行是否包含多个包裹
          const linePackages = this.smartSplitSingleLine(trimmedLine)
          allProcessedLines.push(...linePackages)
        }

        text = allProcessedLines.join('\n')
      }

      return text
    },

    // 改进的单行数据分割逻辑
    smartSplitSingleLine(text) {
      // 优先检测Tab分隔符（参考Inbound实现）
      if (text.indexOf("\t") !== -1) {
        // Tab分隔格式: Tracking<Tab>UPC<Tab>Quantity
        const parts = text.split("\t").map(part => part.trim()).filter(part => part.length > 0)
        if (parts.length === 3 && parts.every(part => part.length > 0)) {
          // 验证是否为有效的三个字段
          const cleanPackage = parts.join(',')
          return [cleanPackage]
        }
      }

      // 统计逗号数量来判断包裹数量
      const commaCount = (text.match(/,/g) || []).length

      // 如果逗号数量能被3整除，说明可能有多个完整包裹
      if (commaCount >= 6 && commaCount % 3 === 0) {
        const expectedPackageCount = commaCount / 3

        // 方法1：尝试用多个空格分割
        let packages = text.split(/\s{2,}/).filter(item => item.trim().length > 0)

        // 如果多空格分割没有得到期望数量，尝试单空格分割
        if (packages.length !== expectedPackageCount) {
          packages = text.split(/\s+/).filter(item => item.trim().length > 0)
        }

        // 验证每个包裹的格式
        const validPackages = []
        for (const item of packages) {
          const trimmed = item.trim()
          const parts = trimmed.split(',')
          if (parts.length === 3 && parts.every(part => part.trim().length > 0)) {
            const cleanPackage = parts.map(part => part.trim()).join(',')
            validPackages.push(cleanPackage)
          }
        }

        if (validPackages.length === expectedPackageCount) {
          return validPackages
        }
      }

      // 方法2：尝试智能分割 - 寻找完整的tracking,product,quantity模式
      if (commaCount >= 3) {
        const intelligentPackages = this.intelligentPackageSplit(text)
        if (intelligentPackages.length > 1) {
          return intelligentPackages
        }
      }

      // 方法3：单个包裹（逗号分隔）
      const singleParts = text.split(',')
      if (singleParts.length === 3 && singleParts.every(part => part.trim().length > 0)) {
        const singlePackage = singleParts.map(part => part.trim()).join(',')
        return [singlePackage]
      }

      return [text.trim()]
    },

    // 智能包裹分割方法
    intelligentPackageSplit(text) {
      // 方法1: 尝试更精确的正则匹配
      const complexMatches = this.complexPatternMatch(text)
      if (complexMatches.length > 1) {
        return complexMatches
      }

      // 方法2: 使用简单的正则表达式匹配 tracking,product,quantity 模式
      const packagePattern = /([A-Za-z0-9]+),([^,\s]+),(\d*)/g
      const matches = []
      let match

      while ((match = packagePattern.exec(text)) !== null) {
        const tracking = match[1].trim()
        const product = match[2].trim()
        const quantity = match[3].trim()

        // 验证必需字段
        if (tracking && product) {
          const cleanPackage = [tracking, product, quantity || ''].join(',')
          matches.push(cleanPackage)
        }
      }

      return matches
    },

    // 复杂模式匹配方法
    complexPatternMatch(text) {

      // 先尝试找到所有可能的tracking号（通常是长数字串）
      const trackingPattern = /\b\d{20,}\b/g
      const trackings = []
      let trackingMatch

      while ((trackingMatch = trackingPattern.exec(text)) !== null) {
        trackings.push({
          value: trackingMatch[0],
          start: trackingMatch.index,
          end: trackingMatch.index + trackingMatch[0].length
        })
      }

      if (trackings.length < 2) {
        return []
      }

      const packages = []

      // 为每个tracking号尝试构建完整的包裹信息
      for (let i = 0; i < trackings.length; i++) {
        const tracking = trackings[i]

        // 确定这个tracking号对应的文本范围
        const nextTrackingStart = i + 1 < trackings.length ? trackings[i + 1].start : text.length
        const packageText = text.substring(tracking.start, nextTrackingStart).trim()

        // 尝试从这段文本中提取product和quantity
        const packageInfo = this.extractPackageInfo(packageText, tracking.value)
        if (packageInfo) {
          packages.push(packageInfo)
        }
      }

      return packages
    },

    // 从文本段中提取包裹信息
    extractPackageInfo(text, tracking) {
      // 移除tracking号，剩余部分包含product和quantity
      const remaining = text.replace(tracking, '').trim()

      // 去掉开头的逗号（如果有）
      const cleaned = remaining.replace(/^,\s*/, '').trim()

      // 尝试用逗号分割剩余部分
      const parts = cleaned.split(',').map(part => part.trim()).filter(part => part.length > 0)

      if (parts.length >= 1) {
        const product = parts[0]
        const quantity = parts.length >= 2 ? parts[1] : ''

        const packageInfo = [tracking, product, quantity].join(',')
        return packageInfo
      }

      return null
    },

    // 手动解析包裹数据（备用方法）
    manualParsePackages(text) {
      // 先检查是否是单个包裹
      const singlePackageTest = text.split(',')
      if (singlePackageTest.length === 3 && singlePackageTest.every(part => part.trim().length > 0)) {
        const cleanedSingle = singlePackageTest.map(part => part.trim()).join(',')
        return [cleanedSingle]
      }

      // 对于多个包裹，使用启发式方法
      // 找到所有逗号的位置
      const commaPositions = []
      for (let i = 0; i < text.length; i++) {
        if (text[i] === ',') {
          commaPositions.push(i)
        }
      }

      // 如果逗号数不是2的倍数，可能格式不正确（因为每个包裹有2个逗号）
      if (commaPositions.length % 2 !== 0) {
        return [text.trim()]
      }

      const packages = []
      // 每2个逗号组成一个包裹（Tracking,UPC,Quantity）
      for (let i = 0; i < commaPositions.length; i += 2) {
        let start = i === 0 ? 0 : commaPositions[i - 1] + 1
        let end = i + 1 < commaPositions.length ? commaPositions[i + 1] : text.length

        // 找到下一个包裹的开始位置（跳过空格）
        if (i + 2 < commaPositions.length) {
          const nextStart = commaPositions[i + 1] + 1
          while (end < text.length && /\s/.test(text[end])) {
            end++
          }
          // 找到下一个非空格字符前的位置
          let nextPackageStart = nextStart
          while (nextPackageStart < text.length && /\s/.test(text[nextPackageStart])) {
            nextPackageStart++
          }

          // 找到下一个包裹的真正开始
          end = nextPackageStart
        }

        const packageText = text.substring(start, end).trim()
        const parts = packageText.split(',')

        if (parts.length === 3 && parts.every(part => part.trim().length > 0)) {
          const cleanedPackage = parts.map(part => part.trim()).join(',')
          packages.push(cleanedPackage)
        }
      }

      if (packages.length > 0) {
        return packages
      }

      return [text.trim()]
    },

    // 初始化Excel上传配置（参考Inbound实现）
    initializeExcelUploadConfig() {
      // 参考Inbound页面的实现，使用同样的配置方式
      this.excelUploadUrl = serverUrl + '/mixed-package/batch/excelImport'
      this.uploadHeaders = {
        Authorization: window.sessionStorage.getItem("authorization")
      }
      // 上传时的额外数据，会在el-upload触发时更新
      this.excelUploadData = {
        batchNumber: this.importForm.batchNumber,
        warehouseNo: this.importForm.warehouseNo
      }
    },

    // 处理Excel上传成功（替换原来的handleExcelChange）
    handleExcelUploadSuccess(response) {
      if (response && (response.code === 200 || response.code === '200')) {
        const result = response.result
        this.showImportResultSummary(result)
        this.closeBatchImportDialog()
      } else {
        this.$message.error(response.message || response.msg || 'Import failed')
      }
      this.excelFileList = []
    },

    // 处理Excel上传错误
    handleExcelUploadError(error) {
      this.$message.error('Excel upload failed: ' + (error.message || 'Unknown error'))
      this.excelFileList = []
    },

    // 处理Excel文件变化（保留用于文件列表管理）
    handleExcelChange(file, fileList) {
      this.excelFileList = fileList
    },

    // 验证导入数据
    async validateImportData() {
      try {
        await this.$refs.importForm.validate()

        if (this.importForm.importMethod === 'text') {
          // Text导入仍使用原来的方式
          await this.executeImport()
        } else {
          // Excel导入使用el-upload方式
          await this.executeExcelUpload()
        }
      } catch (error) {
        // Validation failed
      }
    },

    // 执行Excel上传（使用el-upload方式）
    async executeExcelUpload() {
      if (this.excelFileList.length === 0) {
        this.$message.error('Please select an Excel file first')
        return
      }

      // 更新上传数据
      this.excelUploadData = {
        batchNumber: this.importForm.batchNumber,
        warehouseNo: this.importForm.warehouseNo
      }

      // 触发el-upload的提交
      this.$refs.excelUpload.submit()
    },

    // 执行导入（仅用于Text格式）
    async executeImport() {
      this.importing = true
      try {
        // Text导入 - 先解析文本数据以支持单行多条和多行多条格式
        const parsedTextContent = this.parseTextData(this.importForm.textContent)

        const response = await mixedPackageApi.batchTextImport({
          batchNumber: this.importForm.batchNumber,
          warehouseNo: this.importForm.warehouseNo,
          textContent: parsedTextContent
        })

        if (response && (response.code === 200 || response.code === '200')) {
          const result = response.result
          this.showImportResultSummary(result)
          this.closeBatchImportDialog()
          this.getPendingPackages() // 刷新列表
          this.getAvailableBatches() // 刷新批次列表
        } else {
          this.$message.error(response.message || response.msg || 'Import failed')
        }
      } catch (error) {
        this.$message.error('Import error: ' + error.message)
      } finally {
        this.importing = false
      }
    },

    // 显示导入结果摘要
    showImportResultSummary(result) {

      // Handle different possible data structures
      const failedRecords = result.failedRecords || result.failureRecords || []
      const successTrackings = result.successTrackings || []
      const successDetails = result.successDetails || null

      // Calculate counts if not provided or incorrect
      let totalCount = result.totalCount || 0
      let successCount = result.successCount || 0
      let failedCount = result.failedCount || 0

      // Verify counts against actual data
      if (successTrackings.length > 0 && successCount !== successTrackings.length) {
        successCount = successTrackings.length
      }

      if (failedRecords.length > 0 && failedCount !== failedRecords.length) {
        failedCount = failedRecords.length
      }

      // Calculate total if not provided or incorrect
      const calculatedTotal = successCount + failedCount
      if (totalCount !== calculatedTotal && calculatedTotal > 0) {
        totalCount = calculatedTotal
      }

      // Prepare data for the new ImportResultDialog
      this.importResultData = {
        totalCount,
        successCount,
        failedCount,
        successTrackings,
        successDetails,
        failedRecords: failedRecords.map((record, index) => {
          // Ensure each failed record has necessary properties
          return {
            lineNumber: record.lineNumber || (index + 1),
            rawContent: record.rawContent || record.content || record.data || '',
            content: record.content || record.rawContent || record.data || '',
            errorMessage: record.errorMessage || record.error || record.message || 'Unknown error',
            error: record.error || record.errorMessage || record.message || 'Unknown error'
          }
        })
      }

      // Show the improved dialog
      this.importResultDialogVisible = true
    },

    // Handle import result dialog actions
    handleImportContinue(result) {
      if (result.successCount > 0) {
        this.$message.success(`${result.successCount} tracking(s) imported successfully!`)
        this.getPendingPackages() // Refresh list
      }
    },

    handleImportResultClose() {
      this.importResultDialogVisible = false
    },

    handleRetryFailed(retryInfo) {
      // 将失败的记录重新填充到导入表单中
      this.importForm.textContent = retryInfo.retryData
      this.importResultDialogVisible = false
      this.batchImportDialogVisible = true

      this.$message.info(`Loaded ${retryInfo.failedCount} failed records for retry. Please review and import again.`)
    },

    // 批量确认包裹
    showBulkConfirm() {
      if (this.selectedPackages.length === 0) {
        this.$message.warning('Please select packages to confirm')
        return
      }
      this.bulkConfirmDialogVisible = true
    },

    // 执行批量确认包裹
    async executeBulkConfirm() {
      this.bulkConfirming = true
      try {
        const results = []

        for (const packageRecord of this.selectedPackages) {
          try {
            const response = await mixedPackageApi.confirmSinglePackage({
              id: packageRecord.id,
              batchNumber: packageRecord.batchNumber,
              tracking: packageRecord.tracking
            })

            if (response && (response.code === 200 || response.code === '200')) {
              results.push({
                tracking: packageRecord.tracking,
                success: true,
                result: response.result
              })
            } else {
              results.push({
                tracking: packageRecord.tracking,
                success: false,
                error: response.msg || response.message || response.error || 'Confirmation failed'
              })
            }
          } catch (error) {
            results.push({
              tracking: packageRecord.tracking,
              success: false,
              error: error.message || error.toString() || 'Network or system error'
            })
          }
        }

        // 统计结果
        const successResults = results.filter(r => r.success)
        const failedResults = results.filter(r => !r.success)
        const successCount = successResults.length
        const failedCount = failedResults.length

        // 准备结果数据
        this.bulkConfirmResultData = {
          totalPackages: this.selectedPackages.length,
          successCount: successCount,
          failedCount: failedCount,
          createdPackageIds: successResults.map(r => r.tracking).filter(Boolean), // 显示成功的tracking number
          failureRecords: failedResults.map(r => ({
            tracking: r.tracking,
            errorMessage: this.formatErrorMessage(r.error) || 'Unknown error',
            canRetry: this.determineCanRetry(r.error),
            itemCount: this.getPackageItemCount(r.tracking)
          })),
          batchNumber: (this.selectedPackages[0] && this.selectedPackages[0].batchNumber) || ''
        }

        // 关闭确认对话框
        this.bulkConfirmDialogVisible = false

        // 显示结果对话框
        this.bulkConfirmResultDialogVisible = true

        // 刷新列表
        this.getPendingPackages()
      } catch (error) {
        this.$message.error('Bulk confirmation error: ' + error.message)
      } finally {
        this.bulkConfirming = false
      }
    },

    // 批量取消包裹
    showBatchCancel() {
      if (this.selectedPackages.length === 0) {
        this.$message.warning('Please select packages to remove')
        return
      }

      this.$confirm(`Are you sure to remove ${this.selectedPackages.length} selected packages?`, 'Confirm', {
        confirmButtonText: 'Remove Packages',
        cancelButtonText: 'Keep Packages',
        type: 'warning'
      }).then(() => {
        this.executeBatchCancel()
      }).catch(() => {
        // User cancelled
      })
    },

    // 执行批量取消包裹
    async executeBatchCancel() {
      const loading = this.$loading({
        lock: true,
        text: `Removing ${this.selectedPackages.length} packages...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let successCount = 0
      let failedCount = 0
      const failedPackages = []

      try {
        for (const packageRecord of this.selectedPackages) {
          try {
            const response = await mixedPackageApi.cancelSinglePackage({
              id: packageRecord.id,
              batchNumber: packageRecord.batchNumber,
              tracking: packageRecord.tracking
            })

            if (response && (response.code === 200 || response.code === '200')) {
              successCount++
            } else {
              failedCount++
              failedPackages.push({
                tracking: packageRecord.tracking,
                error: response.msg || 'Unknown error'
              })
            }
          } catch (error) {
            failedCount++
            failedPackages.push({
              tracking: packageRecord.tracking,
              error: error.message
            })
          }
        }

        loading.close()

        if (successCount > 0) {
          this.$message.success(`Batch removal completed! Success: ${successCount}, Failed: ${failedCount}`)
          this.getPendingPackages() // 刷新列表
          this.getAvailableBatches() // 刷新批次列表
        }

        if (failedCount > 0) {
          this.$message.warning(`${failedCount} packages failed to remove.`)
        }

      } catch (error) {
        loading.close()
        this.$message.error('Batch removal error: ' + error.message)
      }
    },

    // 查看包裹详情 (To Confirm Tab - 显示UPC维度)
    async viewPendingPackageDetail(packageRecord) {
      try {
        this.batchDetailLoading = true
        this.batchDetailDialogVisible = true

        // 如果包裹记录已经包含items数据，直接使用
        if (packageRecord.items && packageRecord.items.length > 0) {
          this.currentPackageDetail = packageRecord
        } else {
          // 否则通过API获取包裹详情
          const response = await mixedPackageApi.getPackageDetail({
            id: packageRecord.id,
            batchNumber: packageRecord.batchNumber,
            tracking: packageRecord.tracking
          })
          if (response && (response.code === 200 || response.code === '200')) {
            this.currentPackageDetail = response.result
          } else {
            this.$message.error(response.msg || 'Failed to load package detail')
            this.batchDetailDialogVisible = false
          }
        }
      } catch (error) {
        this.$message.error('Error loading package detail: ' + error.message)
        this.batchDetailDialogVisible = false
      } finally {
        this.batchDetailLoading = false
      }
    },

    // 刷新包裹详情 (To Confirm Tab)
    async refreshPendingPackageDetail() {
      if (this.currentPackageDetail) {
        await this.viewPendingPackageDetail(this.currentPackageDetail)
      }
    },

    // ==================== UPC删除功能 ====================

    // 处理UPC选择变化
    handleUPCSelectionChange(selection) {
      this.selectedUPCs = selection
    },

    // 编辑单个UPC
    editSingleUPC(upcItem, index) {

      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.editUPCForm) {
          this.$refs.editUPCForm.clearValidate()
        }
      })

      // 设置编辑表单数据
      this.editUPCForm = {
        upc: upcItem.upc,
        quantity: upcItem.quantity,
        originalUpc: upcItem.upc,
        originalQuantity: upcItem.quantity
      }
      this.editingUPCIndex = index
      this.editUPCDialog = true
    },

    // 取消UPC编辑
    cancelUPCEdit() {
      this.editUPCDialog = false

      // 重置编辑状态
      this.editingUPCIndex = -1
      this.editUPCForm = {
        upc: '',
        quantity: 1,
        originalUpc: '',
        originalQuantity: 1
      }

      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.editUPCForm) {
          this.$refs.editUPCForm.clearValidate()
        }
      })
    },

    // 保存UPC编辑
    async saveUPCEdit() {
      try {
        // 验证表单
        await this.$refs.editUPCForm.validate()

        // 检查是否有实际变化
        if (this.editUPCForm.upc === this.editUPCForm.originalUpc &&
            this.editUPCForm.quantity === this.editUPCForm.originalQuantity) {
          this.$message.info('No changes detected')
          this.editUPCDialog = false
          return
        }

        this.savingUPCEdit = true

        // 构建API参数
        const editParams = {
          batchNumber: this.currentPackageDetail.batchNumber,
          tracking: this.currentPackageDetail.tracking,
          originalUPC: this.editUPCForm.originalUpc,
          originalQuantity: this.editUPCForm.originalQuantity,
          newUPC: this.editUPCForm.upc,
          newQuantity: this.editUPCForm.quantity
        }

        const response = await mixedPackageApi.editUPCInPackage(editParams)

        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('UPC edited successfully')

          // 立即更新本地数据
          if (this.currentPackageDetail && this.currentPackageDetail.items && this.editingUPCIndex >= 0) {
            // 创建新的数组引用以触发Vue响应式更新
            const updatedItems = [...this.currentPackageDetail.items]
            updatedItems[this.editingUPCIndex] = {
              ...updatedItems[this.editingUPCIndex],
              upc: this.editUPCForm.upc,
              quantity: this.editUPCForm.quantity
            }

            // 使用Vue.set确保响应式更新
            this.$set(this.currentPackageDetail, 'items', updatedItems)

            // 强制Vue重新渲染
            this.$forceUpdate()
          }

          this.editUPCDialog = false

          // 重置编辑状态
          this.editingUPCIndex = -1
          this.editUPCForm = {
            upc: '',
            quantity: 1,
            originalUpc: '',
            originalQuantity: 1
          }

          // 稍微延迟后刷新包裹详情（确保后端数据已更新）
          setTimeout(async () => {
            await this.refreshPendingPackageDetail()
          }, 500)

        } else {
          this.$message.error(response.msg || 'Failed to edit UPC')
        }

      } catch (error) {
        if (error.message) {
          // 表单验证错误
          return
        }
        this.$message.error('Edit failed: ' + (error.message || error))
      } finally {
        this.savingUPCEdit = false
      }
    },

    // 删除单个UPC
    async deleteSingleUPC(upcItem, index) {
      try {
        await this.$confirm(`Are you sure to delete this UPC item?

UPC: ${upcItem.upc}
Quantity: ${upcItem.quantity}
Product: ${upcItem.productName || 'N/A'}

This action cannot be undone.`, 'Confirm Delete UPC', {
          confirmButtonText: 'Yes, Delete',
          cancelButtonText: 'Cancel',
          type: 'warning',
          dangerouslyUseHTMLString: true
        })

        // 调用删除UPC的API
        await this.deleteUPCFromPackage([upcItem])

      } catch (error) {
        if (error !== 'cancel') {
          // User cancelled or delete failed
        }
      }
    },

    // 批量删除UPC
    async bulkDeleteUPCs() {
      if (this.selectedUPCs.length === 0) {
        this.$message.warning('Please select UPC items to delete')
        return
      }

      try {
        const upcList = this.selectedUPCs.map(item => `${item.upc} (${item.quantity})`).join('\n')

        await this.$confirm(`Are you sure to delete ${this.selectedUPCs.length} UPC item(s)?

${upcList}

This action cannot be undone.`, 'Confirm Bulk Delete', {
          confirmButtonText: 'Yes, Delete All',
          cancelButtonText: 'Cancel',
          type: 'warning',
          dangerouslyUseHTMLString: true
        })

        // 调用删除UPC的API
        await this.deleteUPCFromPackage(this.selectedUPCs)

      } catch (error) {
        if (error !== 'cancel') {
          // User cancelled or bulk delete failed
        }
      }
    },

    // 删除UPC的API调用（通用方法）
    async deleteUPCFromPackage(upcItems) {
      const loading = this.$loading({
        lock: true,
        text: `Deleting ${upcItems.length} UPC item(s)...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 构建删除参数
        const deleteParams = {
          batchNumber: this.currentPackageDetail.batchNumber,
          tracking: this.currentPackageDetail.tracking,
          upcItems: upcItems.map(item => ({
            upc: item.upc,
            quantity: item.quantity
          }))
        }

        // 调用后端API删除UPC
        const response = await mixedPackageApi.deleteUPCFromPackage(deleteParams)

        if (response && (response.code === 200 || response.code === '200')) {
          const result = response.result

          // 显示详细的删除结果
          let message = `Successfully deleted ${result.deletedCount}/${result.requestedCount} UPC item(s)`

          if (result.deletedCount < result.requestedCount) {
            message += `\nNote: ${result.requestedCount - result.deletedCount} item(s) were not found or already deleted`
          }

          if (result.warning) {
            message += `\n⚠️ ${result.warning}`
          }

          this.$message.success(message)

          // 立即从当前数据中移除已删除的UPC项
          if (this.currentPackageDetail && this.currentPackageDetail.items) {
            const deletedUPCs = upcItems.map(item => item.upc)
            this.currentPackageDetail.items = this.currentPackageDetail.items.filter(
              item => !deletedUPCs.includes(item.upc)
            )
            // 更新总数量统计
            this.currentPackageDetail.itemCount = this.currentPackageDetail.items.length

            // 检查是否删除了所有UPC项
            if (this.currentPackageDetail.items.length === 0) {
              // 所有UPC都被删除，包裹已经被自动清理
              this.$message.success('All UPC items have been deleted. The package has been automatically removed from pending list.')

              // 关闭详情对话框
              this.batchDetailDialogVisible = false

              // 刷新待确认包裹列表
              this.$nextTick(() => {
                this.getPendingPackages()
              })

              return // 直接返回，不需要继续后续操作
            }

            // 强制Vue重新渲染
            this.$forceUpdate()
          }

        } else {
          throw new Error(response.msg || 'Delete UPC failed')
        }

        // 清除选择
        this.selectedUPCs = []
        if (this.$refs.upcTable) {
          this.$refs.upcTable.clearSelection()
        }

        // 异步刷新包裹详情（确保数据同步）
        this.$nextTick(async () => {
          await this.refreshPendingPackageDetail()
        })

      } catch (error) {
        this.$message.error('Delete failed: ' + (error.message || error))
      } finally {
        loading.close()
      }
    },

    // 从详情页确认单个包裹
    async confirmBatchFromDetail() {
      if (this.currentPackageDetail) {
        await this.confirmSinglePackage(this.currentPackageDetail)
        this.batchDetailDialogVisible = false
      }
    },

    // 单个包裹撤销
    async reversePackage(packageId) {
      try {
        await this.$confirm('Are you sure to reverse this package?', 'Confirm', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        const response = await mixedPackageApi.reverseByPackageId({ packageId })
        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Package reversed successfully')
          this.getMixedPackageList()
        } else {
          this.$message.error(response.message || response.msg || 'Failed to reverse package')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Error reversing package: ' + error.message)
        }
      }
    },

    // 查看包裹详情
    viewPackageDetail(row) {

      if (!row.mixedPackageId) {
        this.$message.error('Package ID not found')
        return
      }

      this.packageDetailLoading = true

      mixedPackageApi.getMixedPackageDetail(row.mixedPackageId).then(res => {
        this.packageDetailLoading = false

        if (res.code === 200 || res.code === '200') {
          this.currentPackageDetail = res.result || res.data
          this.packageDetailDialogVisible = true
        } else {
          this.$message.error(res.message || res.msg || 'Failed to load package details')
        }
      }).catch(err => {
        this.packageDetailLoading = false
        this.$message.error(err.message || 'Failed to load package details')
      })
    },

    // ==================== 认领审核功能 ====================

    // 单个认领批准
    async approveSingleClaim(claim) {
      try {
        await this.$confirm('Are you sure to approve this claim?', 'Confirm', {
          confirmButtonText: 'Approve',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        const response = await mixedPackageApi.approveClaim(claim.claimId)
        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Claim approved successfully')
          this.getClaimList()
        } else {
          this.$message.error(response.msg || 'Failed to approve claim')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Error approving claim: ' + error.message)
        }
      }
    },

    // 单个认领下放
    async distributeSingleClaim(claim) {
      try {
        await this.$confirm('Are you sure to distribute this claim to inventory?', 'Confirm Distribution', {
          confirmButtonText: 'Distribute',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        const response = await mixedPackageApi.batchDistribute({
          claimIds: [claim.claimId]
        })
        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Claim distributed successfully')
          this.getClaimList()
          this.getMixedPackageList() // 刷新包裹列表
        } else {
          this.showFormattedError(response.msg || 'Failed to distribute claim', 'Distribute Failed')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.showFormattedError('Error distributing claim: ' + error.message, 'Distribute Error')
        }
      }
    },

    // 显示调整认领对话框
    showAdjustClaim(claim) {
      this.currentClaimForAdjust = claim
      this.adjustForm.newQuantity = claim.claimedQty
      this.adjustForm.adjustReason = ''
      this.adjustClaimDialogVisible = true
    },

    // 执行调整认领
    async executeAdjustClaim() {
      try {
        await this.$refs.adjustForm.validate()

        this.adjusting = true
        const response = await mixedPackageApi.adjustClaimQuantity(
          this.currentClaimForAdjust.claimId,
          {
            newQuantity: this.adjustForm.newQuantity,
            adjustReason: this.adjustForm.adjustReason
          }
        )

        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Claim quantity adjusted successfully')
          this.adjustClaimDialogVisible = false
          this.getClaimList()
        } else {
          this.$message.error(response.msg || 'Failed to adjust claim quantity')
        }
      } catch (error) {
        this.$message.error('Error adjusting claim: ' + error.message)
      } finally {
        this.adjusting = false
      }
    },

    // 显示拒绝认领对话框
    showRejectClaim(claim) {
      this.currentClaimForReject = claim
      this.rejectForm.rejectReason = ''
      this.rejectClaimDialogVisible = true
    },

    // 执行拒绝认领
    async executeRejectClaim() {
      try {
        await this.$refs.rejectForm.validate()

        this.rejecting = true
        const response = await mixedPackageApi.rejectClaim(
          this.currentClaimForReject.claimId,
          {
            rejectReason: this.rejectForm.rejectReason
          }
        )

        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Claim rejected successfully')
          this.rejectClaimDialogVisible = false
          this.getClaimList()
        } else {
          this.$message.error(response.msg || 'Failed to reject claim')
        }
      } catch (error) {
        this.$message.error('Error rejecting claim: ' + error.message)
      } finally {
        this.rejecting = false
      }
    },

    // 显示批量审批对话框
    showBatchApprove() {
      if (this.selectedClaims.length === 0) {
        this.$message.warning('Please select claims to approve')
        return
      }

      // 过滤出只有待审核状态的认领
      const pendingClaims = this.selectedClaims.filter(claim => claim.claimStatus === 0)
      if (pendingClaims.length === 0) {
        this.$message.warning('No pending claims selected')
        return
      }

      if (pendingClaims.length < this.selectedClaims.length) {
        this.$message.warning(`Only ${pendingClaims.length} of ${this.selectedClaims.length} selected claims are pending for approval`)
      }

      this.selectedClaims = pendingClaims
      this.batchApproveDialogVisible = true
    },

    // 执行批量审批
    async executeBatchApprove() {
      this.batchApproving = true
      try {
        const claimIds = this.selectedClaims.map(claim => claim.claimId)
        const response = await mixedPackageApi.batchApprove({ claimIds })

        if (response && (response.code === 200 || response.code === '200')) {
          const result = response.result
          this.$message.success(`Batch approval completed! Approved: ${result.successCount}, Failed: ${result.failedCount}`)
          this.batchApproveDialogVisible = false
          this.getClaimList()
        } else {
          this.$message.error(response.msg || 'Batch approval failed')
        }
      } catch (error) {
        this.$message.error('Batch approval error: ' + error.message)
      } finally {
        this.batchApproving = false
      }
    },

    // 显示批量下放对话框
    showBatchDistribute() {
      if (this.selectedClaims.length === 0) {
        this.$message.warning('Please select claims to distribute')
        return
      }

      // 过滤出只有已批准状态的认领
      const approvedClaims = this.selectedClaims.filter(claim => claim.claimStatus === 1)
      if (approvedClaims.length === 0) {
        this.$message.warning('No approved claims selected')
        return
      }

      if (approvedClaims.length < this.selectedClaims.length) {
        this.$message.warning(`Only ${approvedClaims.length} of ${this.selectedClaims.length} selected claims are approved for distribution`)
      }

      this.selectedClaims = approvedClaims
      this.batchDistributeDialogVisible = true
    },

    // 执行批量下放
    async executeBatchDistribute() {
      this.batchDistributing = true
      try {
        const claimIds = this.selectedClaims.map(claim => claim.claimId)
        const response = await mixedPackageApi.batchDistribute({
          claimIds
        })

        if (response && (response.code === 200 || response.code === '200')) {
          const result = response.result
          this.$message.success(`Batch distribution completed! Distributed: ${result.successCount}, Failed: ${result.failedCount}`)
          this.batchDistributeDialogVisible = false
          this.getClaimList()
          this.getMixedPackageList() // 刷新包裹列表状态
        } else {
          this.$message.error(response.msg || 'Batch distribution failed')
        }
      } catch (error) {
        this.$message.error('Batch distribution error: ' + error.message)
      } finally {
        this.batchDistributing = false
      }
    },

    // 显示设置强制收费时间对话框
    showSetForceChargeTime() {
      if (this.selectedClaims.length === 0) {
        this.$message.warning('Please select claims to set force charge time')
        return
      }

      this.forceChargeForm.forceChargeTime = ''
      this.forceChargeForm.reason = ''
      this.forceChargeTimeDialogVisible = true
    },

    // 执行设置强制收费时间
    async executeSetForceChargeTime() {
      try {
        await this.$refs.forceChargeForm.validate()

        this.settingForceCharge = true
        const claimIds = this.selectedClaims.map(claim => claim.claimId)
        const response = await mixedPackageApi.setForceChargeTime({
          claimIds,
          forceChargeTime: this.forceChargeForm.forceChargeTime,
          reason: this.forceChargeForm.reason
        })

        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Force charge time set successfully')
          this.forceChargeTimeDialogVisible = false
          this.getClaimList()
        } else {
          this.$message.error(response.msg || 'Failed to set force charge time')
        }
      } catch (error) {
        this.$message.error('Error setting force charge time: ' + error.message)
      } finally {
        this.settingForceCharge = false
      }
    },

    showBulkReverse() {
      if (!this.selectedPackages || this.selectedPackages.length === 0) {
        this.$message.warning('Please select packages to reverse')
        return
      }

      // 统一逻辑：所有包裹都可以撤销
      const reversiblePackages = this.selectedPackages

      let actionDescription = 'This will process each package according to its type:'
      actionDescription += '\n• Manual packages: Direct deletion'
      actionDescription += '\n• Batch imported packages: Restore to pending batch'
      actionDescription += '\n• Packages with claims: Reverse claims and inventory'

      const message = `Are you sure to reverse ${reversiblePackages.length} package(s)?

${actionDescription}

This action cannot be undone.`

      this.$confirm(message, 'Confirm Bulk Reverse', {
        type: 'warning',
        confirmButtonText: 'Yes, Reverse All',
        cancelButtonText: 'Cancel'
      }).then(() => {
        this.executeBulkReverse(reversiblePackages)
      }).catch(() => {
        // User cancelled bulk reverse
      })
    },

    async executeBulkReverse(packages) {
      const loading = this.$loading({
        lock: true,
        text: `Reversing ${packages.length} packages...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let successCount = 0
      let failedCount = 0
      const failedPackages = []

      try {
        for (const pkg of packages) {
          try {
            console.log(`Processing package: ${pkg.tracking}, ID: ${pkg.mixedPackageId}`)
            const response = await mixedPackageApi.reverseByPackageId({
              packageId: pkg.mixedPackageId
            })

            if (response && (response.code === 200 || response.code === '200')) {
              successCount++
              console.log(`Package ${pkg.tracking} reversed successfully`)
            } else {
              failedCount++
              const errorMsg = response.message || response.msg || 'Unknown error'
              console.log(`Package ${pkg.tracking} failed: ${errorMsg}`)
              failedPackages.push({
                tracking: pkg.tracking,
                error: errorMsg
              })
            }
          } catch (error) {
            failedCount++
            console.log(`Package ${pkg.tracking} error: ${error.message}`)
            failedPackages.push({
              tracking: pkg.tracking,
              error: error.message || 'Network or system error'
            })
          }
        }

        loading.close()

        if (successCount > 0) {
          this.$message.success(`Bulk reverse completed! Success: ${successCount}, Failed: ${failedCount}`)
          this.getMixedPackageList() // 刷新列表
        }

        if (failedCount > 0) {
          // Show detailed error messages using MessageBox for better display
          const errorList = failedPackages.map((fp, index) =>
            `${index + 1}. Tracking: ${fp.tracking}\n   Error: ${fp.error}`
          ).join('\n\n')

          this.$msgbox({
            title: `Bulk Reverse Failed (${failedCount} packages)`,
            message: errorList,
            type: 'error',
            showClose: true,
            closeOnClickModal: true,
            confirmButtonText: 'OK'
          }).catch(() => {
            // User closed the dialog
          })

          // Also show a brief summary message
          this.$message.warning(`${failedCount} packages failed to reverse. See details above.`)
        }

      } catch (error) {
        loading.close()
        this.$message.error('Bulk reverse error: ' + error.message)
      }
    },

    // 批次批量撤销功能
    async showBatchBulkReverse() {
      try {
        // 获取可用的批次号列表
        await this.getAvailableBatchNumbers()
        this.selectedBatchNumber = ''
        this.batchPackagesList = []
        this.batchBulkReverseDialogVisible = true
      } catch (error) {
        this.$message.error('Failed to load batch numbers: ' + error.message)
      }
    },

    async getAvailableBatchNumbers() {
      try {
        // 调用混寄包裹的批次号获取API (类似inbound的getBatchNumberList)
        const response = await mixedPackageApi.getBatchNumbers({})

        if (response && (response.code === 200 || response.code === '200')) {
          this.availableBatchNumbers = response.result || []
        } else {
          throw new Error(response.message || response.msg || 'Failed to get batch numbers')
        }
      } catch (error) {
        throw error
      }
    },

    async changeBatchNumberForBulkReverse() {
      if (!this.selectedBatchNumber) {
        this.batchPackagesList = []
        return
      }

      this.batchPackagesLoading = true
      try {
        // 根据批次号获取该批次的所有包裹列表（不限制状态）
        const response = await mixedPackageApi.getPackagesByBatchNumber({
          batchNumber: this.selectedBatchNumber
          // 移除 status 参数，显示所有状态的包裹
        })

        if (response && (response.code === 200 || response.code === '200')) {
          this.batchPackagesList = response.result || []
        } else {
          throw new Error(response.message || response.msg || 'Failed to get packages')
        }
      } catch (error) {
        this.$message.error('Failed to load packages: ' + error.message)
        this.batchPackagesList = []
      } finally {
        this.batchPackagesLoading = false
      }
    },

    async executeBatchBulkReverse() {
      if (!this.selectedBatchNumber || this.batchPackagesList.length === 0) {
        this.$message.warning('Please select a batch and ensure there are packages to reverse')
        return
      }

      const confirmMessage = `Are you sure to reverse ALL ${this.batchPackagesList.length} package(s) in batch "${this.selectedBatchNumber}"?

This will:
- Cancel all mixed packages in this batch
- Release all claimed items back to inventory
- Remove all package records from the system

This action cannot be undone.`

      try {
        await this.$confirm(confirmMessage, 'Confirm Batch Bulk Reverse', {
          type: 'warning',
          confirmButtonText: 'Yes, Reverse All',
          cancelButtonText: 'Cancel'
        })

        this.batchBulkReverseLoading = true

        // 调用批次批量撤销API
        const response = await mixedPackageApi.batchBulkReverse({
          batchNumber: this.selectedBatchNumber
        })

        if (response && (response.code === 200 || response.code === '200')) {
          const result = response.result
          this.$message.success(`Batch bulk reverse completed! Reversed: ${result.successCount || this.batchPackagesList.length} packages`)

          // 关闭对话框并刷新列表
          this.batchBulkReverseDialogVisible = false
          this.getMixedPackageList()

          // 如果当前在To Confirm tab，也刷新待确认列表
          if (this.activeTabName === 'pending') {
            this.getPendingPackages()
          }
        } else {
          throw new Error(response.message || response.msg || 'Batch reverse failed')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Batch bulk reverse error: ' + error.message)
        }
      } finally {
        this.batchBulkReverseLoading = false
      }
    },

    // 显示编辑UPC数量对话框
    showEditUPCQty(detailRow) {
      this.editMixedPackageUPCQtyForm = {
        detailId: detailRow.detailId,
        mixedPackageId: this.currentPackageDetail.mixedPackageId,
        upc: detailRow.upc,
        productName: detailRow.productName,
        currentTotalQty: detailRow.totalQty,
        claimedQty: detailRow.claimedQty,
        newTotalQty: detailRow.totalQty,
        reason: ''
      }
      this.editMixedPackageUPCQtyDialog = true
    },

    // 确认编辑混寄包裹UPC数量
    confirmEditMixedPackageUPCQty() {
      this.$refs.editMixedPackageUPCQtyForm.validate(async valid => {
        if (!valid) {
          return
        }

        const { newTotalQty, currentTotalQty, claimedQty, detailId } = this.editMixedPackageUPCQtyForm

        // 检查新数量是否小于已认领数量
        if (newTotalQty < claimedQty) {
          this.$message.error(`New total quantity (${newTotalQty}) cannot be less than claimed quantity (${claimedQty})`)
          return
        }

        // 如果数量没有变化，不需要更新
        if (newTotalQty === currentTotalQty) {
          this.$message.warning('Quantity has not changed')
          return
        }

        try {
          this.editingMixedPackageUPCQty = true

          const params = {
            detailId: detailId,
            newTotalQty: newTotalQty
          }

          const response = await mixedPackageApi.updateMixedPackageUPCQty(params)

          if (response && (response.code === 200 || response.code === '200')) {
            this.$message.success('UPC quantity updated successfully')
            this.editMixedPackageUPCQtyDialog = false

            // 刷新包裹详情
            await this.refreshMixedPackageDetail()
          } else {
            throw new Error(response.message || response.msg || 'Update failed')
          }
        } catch (error) {
          this.$message.error('Update error: ' + error.message)
        } finally {
          this.editingMixedPackageUPCQty = false
        }
      })
    },

    // 导出待确认批次
    async exportPendingBatches() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出待确认批次数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 构建查询参数，包含当前的筛选条件
        const exportParams = {
          batchFilter: this.filters.batchFilter,
          trackingFilter: this.filters.trackingFilter
        }

        // 调用API进行导出
        const blob = await mixedPackageApi.exportPendingBatches(exportParams)

        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url

        // 生成文件名，包含当前时间戳
        const now = new Date()
        const timestamp = now.toISOString().slice(0, 19).replace(/[:T]/g, '-')
        link.download = `pending_batches_${timestamp}.xls`

        document.body.appendChild(link)
        link.click()

        // 清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 100)

        this.$message.success('导出成功！文件已开始下载')
      } catch (error) {
        console.error('Export pending batches error:', error)
        this.$message.error('导出失败: ' + (error.message || '未知错误'))
      } finally {
        loading.close()
      }
    },

    exportPackages() {
      this.$message.info('Export packages')
    },

    exportClaims() {
      this.$message.info('Export claims')
    },

    // 导出未认领商品 - 参考Inbound界面的实现方式
    exportUnclaimed() {
      const loading = this.$loading({
        lock: true,
        text: 'Exporting unclaimed items...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 准备导出参数，包含当前的筛选条件
      const params = {
        ...this.unclaimedFilters
        // 不传分页参数，导出所有符合条件的数据
        // 不传warehouseNo，与列表查询保持一致
      }

      mixedPackageApi.exportUnclaimedItems(params).then(data => {
        loading.close()

        // 创建下载链接
        const blob = new Blob([data], { type: "application/vnd.ms-excel" })

        // 生成文件名
        const now = new Date()
        const timestamp = now.getFullYear() +
          String(now.getMonth() + 1).padStart(2, '0') +
          String(now.getDate()).padStart(2, '0') + '_' +
          String(now.getHours()).padStart(2, '0') +
          String(now.getMinutes()).padStart(2, '0')

        const fileName = `unclaimed_items_${timestamp}.xlsx`

        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }

        this.$message.success('Export completed successfully')
      }).catch(error => {
        loading.close()
        this.$message.error('Export failed. Please try again.')
      })
    },


    // 确认单个批次
    async confirmSingleBatch(batchNumber) {
      try {
        await this.$confirm('Are you sure to confirm this batch?', 'Confirm', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        const response = await mixedPackageApi.bulkConfirmBatch({ batchNumber })
        if (response && (response.code === 200 || response.code === '200')) {
          const result = response.result
          this.$message.success(`Batch confirmed! Created ${result.successCount} packages, ${result.failedCount} failed`)
          this.getPendingPackages() // 刷新列表
          this.getAvailableBatches() // 刷新批次列表
        } else {
          this.$message.error(response.msg || 'Failed to confirm batch')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Error confirming batch: ' + error.message)
        }
      }
    },

    // 确认单个包裹
    async confirmSinglePackage(packageRecord) {
      try {
        await this.$confirm('Are you sure to confirm this package?', 'Confirm', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        const response = await mixedPackageApi.confirmSinglePackage({
          id: packageRecord.id,
          batchNumber: packageRecord.batchNumber,
          tracking: packageRecord.tracking
        })

        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Package confirmed successfully!')
          this.getPendingPackages() // 刷新列表
          this.getAvailableBatches() // 刷新批次列表
        } else {
          this.$message.error(response.msg || response.message || 'Failed to confirm package')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Error confirming package: ' + error.message)
        }
      }
    },

    // 取消单个包裹
    async cancelSinglePackage(packageRecord) {
      try {
        await this.$confirm('Are you sure to remove this package?', 'Confirm', {
          confirmButtonText: 'Remove Package',
          cancelButtonText: 'Keep Package',
          type: 'warning'
        })

        const response = await mixedPackageApi.cancelSinglePackage({
          id: packageRecord.id,
          batchNumber: packageRecord.batchNumber,
          tracking: packageRecord.tracking
        })
        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Package removed successfully')
          this.getPendingPackages() // 刷新列表
          this.getAvailableBatches() // 刷新批次列表
        } else {
          this.$message.error(response.msg || 'Failed to remove package')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Error removing package: ' + error.message)
        }
      }
    },

    // 取消单个批次
    async cancelSingleBatch(batchNumber) {
      try {
        await this.$confirm('Are you sure to cancel this batch? All pending records will be deleted.', 'Confirm', {
          confirmButtonText: 'Cancel Batch',
          cancelButtonText: 'Keep Batch',
          type: 'warning'
        })

        const response = await mixedPackageApi.cancelPendingBatch(batchNumber)
        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Batch cancelled successfully')
          this.getPendingPackages() // 刷新列表
          this.getAvailableBatches() // 刷新批次列表
        } else {
          this.$message.error(response.msg || 'Failed to cancel batch')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Error cancelling batch: ' + error.message)
        }
      }
    },

    // 撤销单个包裹
    async reversePackage(mixedPackageId) {
      try {
        const response = await mixedPackageApi.reverseByPackageId({
          packageId: mixedPackageId
        })

        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Package reversed successfully')
          this.getMixedPackageList() // 刷新包裹列表
        } else {
          this.$message.error(response.message || response.msg || 'Failed to reverse package')
        }
      } catch (error) {
        this.$message.error('Error reversing package: ' + error.message)
      }
    },

    // 刷新包裹详情 (Mixed Packages Tab)
    async refreshMixedPackageDetail() {
      if (this.currentPackageDetail && this.currentPackageDetail.mixedPackageId) {
        await this.viewPackageDetail({ mixedPackageId: this.currentPackageDetail.mixedPackageId })
      }
    },

    // 从详情页面撤销包裹
    reversePackageFromDetail() {
      if (!this.currentPackageDetail) {
        this.$message.error('No package selected')
        return
      }

      this.$confirm('Are you sure to reverse this package?', 'Confirm', {
        type: 'warning'
      }).then(async () => {
        try {
          const response = await mixedPackageApi.reverseByPackageId({
            packageId: this.currentPackageDetail.mixedPackageId
          })

          if (response && (response.code === 200 || response.code === '200')) {
            this.$message.success('Package reversed successfully')
            this.packageDetailDialogVisible = false
            this.getMixedPackageList() // 刷新包裹列表
          } else {
            this.$message.error(response.message || response.msg || 'Failed to reverse package')
          }
        } catch (error) {
          this.$message.error('Error reversing package: ' + error.message)
        }
      }).catch(() => {
        // User cancelled
      })
    },

    // ==================== 包裹管理功能方法 ====================

    // 显示创建包裹对话框
    showCreatePackage() {
      this.createPackageDialog = true
      this.createPackageForm = {
        tracking: '',
        warehouseNo: null,
        items: [{ upc: '', qty: 1 }]
      }
    },

    // 添加包裹项目
    addPackageItem() {
      this.createPackageForm.items.push({ upc: '', qty: 1 })
    },

    // 移除包裹项目
    removePackageItem(index) {
      if (this.createPackageForm.items.length > 1) {
        this.createPackageForm.items.splice(index, 1)
      } else {
        this.$message.warning('At least one item is required')
      }
    },

    // 创建混寄包裹
    createMixedPackage() {
      this.$refs.createPackageForm.validate(valid => {
        if (valid) {
          // 验证商品列表
          const validItems = this.createPackageForm.items.filter(item => item.upc && item.qty > 0)

          if (validItems.length === 0) {
            this.$message.error('Please add at least one valid item')
            return
          }

          // 去重处理：使用Map来确保UPC唯一性，同时合并数量
          const upcMap = new Map()
          for (const item of validItems) {
            const upc = item.upc.trim()
            if (upcMap.has(upc)) {
              const existingItem = upcMap.get(upc)
              existingItem.qty += item.qty
            } else {
              upcMap.set(upc, { upc: upc, qty: item.qty })
            }
          }

          // 转换为数组
          const deduplicatedItems = Array.from(upcMap.values())

          this.createPackageLoading = true
          const params = {
            ...this.createPackageForm,
            items: deduplicatedItems
          }

          mixedPackageApi.createMixedPackage(params).then(res => {
            this.createPackageLoading = false

            if (res.code === 200 || res.code === '200') {
              this.$message.success('Mixed package created successfully')
              this.createPackageDialog = false
              this.resetCreateForm()
              this.getMixedPackageList()
            } else {
              this.$message.error(res.message || res.msg || 'Create failed')
            }
          }).catch(err => {
            this.createPackageLoading = false
            this.$message.error(err.message || 'Create failed')
          })
        }
      })
    },

    // 重置创建表单
    resetCreateForm() {
      this.createPackageForm = {
        tracking: '',
        warehouseNo: null,
        items: [{ upc: '', qty: 1 }]
      }
      this.createPackageLoading = false
      this.$nextTick(() => {
        if (this.$refs.createPackageForm) {
          this.$refs.createPackageForm.resetFields()
        }
      })
    },

    // 取消创建包裹
    cancelCreatePackage() {
      this.createPackageDialog = false
      this.resetCreateForm()
    },

    // 查看包裹认领
    viewClaimsForPackage(row) {
      this.activeName = 'claims'
      this.claimFilters.tracking = row.tracking  // 设置tracking过滤条件
      this.$nextTick(() => {
        this.getClaimList()
      })
    },

    // 撤销包裹方法 - 统一处理所有状态的包裹

    confirmReversePackage(row) {
      // 根据包裹状态和认领情况生成不同的提示信息
      let actionDescription = ''
      if (row.packageStatus === 0) {
        actionDescription = 'This will delete the package record.'
      } else if (row.claimedItems > 0) {
        actionDescription = 'This will reverse all claims and restore inventory.'
      } else {
        actionDescription = 'This will delete the package record and restore it to pending batch for re-confirmation.'
      }

      const message = `Are you sure to reverse this package?

Tracking: ${row.tracking}
Status: ${this.getStatusText(row.packageStatus)}
Items: ${row.totalItems || 0} items
${row.claimedItems > 0 ? `Claims: ${row.claimedItems} claimed` : ''}

${actionDescription} This action cannot be undone.`

      this.$confirm(message, 'Confirm Reverse Package', {
        type: 'warning',
        confirmButtonText: 'Yes, Reverse Package',
        cancelButtonText: 'No, Keep Package'
      }).then(() => {
        this.reversePackage(row.mixedPackageId)
      }).catch(() => {
        // 用户取消了撤销操作
      })
    },

    // 获取仓库列表（用于Mixed Packages Tab等）
    async getWarehouseList() {
      try {
        // 使用当前公司信息获取仓库列表
        const currentCompany = window.sessionStorage.getItem("currentCompany")

        const response = await getWarehouseForWarehouseAdmin({
          doctorNo: currentCompany
        })

        if (response.code === 200 || response.code === '200') {
          this.warehouses = response.records || []
        } else {
          this.$message.error('Failed to load warehouses: ' + (response.msg || response.message || 'Unknown error'))
          // 如果API失败，使用空数组而不是硬编码数据
          this.warehouses = []
        }

        // 如果只有一个仓库，自动选择作为默认筛选条件
        if (this.warehouses.length === 1) {
          this.packageFilters.warehouseNo = this.warehouses[0].warehouseNo
          this.getMixedPackageList()
        }
      } catch (error) {
        this.$message.error('获取仓库列表失败: ' + error.message)
        this.warehouses = []
      }
    },

    // ==================== 辅助方法 ====================
    getStatusText(status) {
      const statusMap = {
        0: 'Pending',
        1: 'Partial Claimed',
        2: 'All Claimed',
        3: 'Completed'
      }
      return statusMap[status] || 'Unknown'
    },

    getStatusTagType(status) {
      const typeMap = {
        0: '',
        1: 'warning',
        2: 'success',
        3: 'info'
      }
      return typeMap[status] || ''
    },

    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString()
    },

    getDetailStatusTagType(status) {
      const typeMap = {
        0: '',
        1: 'warning',
        2: 'success'
      }
      return typeMap[status] || ''
    },

    getDetailStatusText(status) {
      const statusMap = {
        0: 'Unclaimed',
        1: 'Partially Claimed',
        2: 'Fully Claimed'
      }
      return statusMap[status] || 'Unknown'
    },

    getClaimStatusTagType(status) {
      const typeMap = {
        0: 'warning', // 待审核
        1: 'success', // 已批准
        2: 'success', // 已下发
        3: 'danger',  // 已拒绝
        4: 'warning'  // 数量已调整
      }
      return typeMap[status] || ''
    },

    getClaimStatusText(status) {
      const statusMap = {
        0: 'Pending Review',
        1: 'Approved',
        2: 'Distributed',
        3: 'Rejected',
        4: 'Quantity Adjusted'
      }
      return statusMap[status] || 'Unknown'
    },

    // ==================== Tracking处理方法 ====================

    // 获取tracking数组
    getTrackingArray(trackingList) {
      if (!trackingList) return []

      // 如果已经是数组，直接返回
      if (Array.isArray(trackingList)) {
        return trackingList.filter(tracking => tracking && tracking.trim())
      }

      // 如果是字符串，按逗号分割
      if (typeof trackingList === 'string') {
        return trackingList.split(',').map(tracking => tracking.trim()).filter(tracking => tracking)
      }

      return []
    },

    // 获取显示用的tracking (截断过长的tracking)
    getDisplayTracking(tracking) {
      if (!tracking) return ''

      // 如果tracking太长，截断并添加省略号
      if (tracking.length > 15) {
        return tracking.substring(0, 12) + '...'
      }

      return tracking
    },

    // ==================== 认领相关核心方法 ====================

    // 刷新待审核数量
    refreshPendingCount() {
      mixedPackageApi.countPendingClaims().then(res => {
        if (res.code === 200 || res.code === '200') {
          this.pendingClaimsCount = res.result || res.data || 0
        }
      }).catch(() => {
        // 忽略错误，避免干扰用户
      })
    },

    // 批准单个认领
    approveClaim(row) {
      this.$confirm('Are you sure to approve this claim?', 'Confirm', {
        type: 'warning'
      }).then(() => {
        mixedPackageApi.approveClaim(row.claimId).then(res => {
          if (res.code === 200 || res.code === '200') {
            this.$message.success('Claim approved successfully')
            this.getClaimList()
            this.refreshPendingCount()
          } else {
            this.$message.error(res.message || 'Approve failed')
          }
        }).catch(err => {
          this.$message.error(err.message || 'Approve failed')
        })
      })
    },

    // 显示单个下发对话框
    showSingleDistribute(row) {
      this.singleDistributeClaim = row
      this.singleDistributeForm = {
        chargeTimeOption: 'normal',
        customChargeTime: null
      }
      this.singleDistributeDialog = true
    },

    // 确认单个下发
    confirmSingleDistribute() {
      // 验证自定义时间
      if (this.singleDistributeForm.chargeTimeOption === 'custom' && !this.singleDistributeForm.customChargeTime) {
        this.$message.error('Please select custom charge time')
        return
      }

      this.singleDistributeLoading = true

      // 构建请求参数
      let forceChargeTime = null
      if (this.singleDistributeForm.chargeTimeOption === 'immediate') {
        forceChargeTime = new Date()
      } else if (this.singleDistributeForm.chargeTimeOption === 'custom') {
        forceChargeTime = new Date(this.singleDistributeForm.customChargeTime)
      }

      const params = {
        claimIds: this.singleDistributeClaim.claimId.toString()
      }

      if (forceChargeTime) {
        params.forceChargeTime = forceChargeTime
      }

      mixedPackageApi.batchDistribute(params).then(res => {
        if (res.code === 200 || res.code === '200') {
          this.$message.success('Inventory distributed successfully')
          this.singleDistributeDialog = false
          this.singleDistributeClaim = null
          this.getClaimList()
        } else {
          this.showFormattedError(res.message || 'Distribute failed', 'Distribute Failed')
        }
        this.singleDistributeLoading = false
      }).catch(err => {
        this.showFormattedError(err.message || 'Distribute failed', 'Distribute Error')
        this.singleDistributeLoading = false
      })
    },

    // 显示调整数量对话框
    showAdjustQuantity(row) {
      this.adjustQuantityForm = {
        claimId: row.claimId,
        originalQty: row.claimedQty,
        newQuantity: row.claimedQty,
        maxQty: row.unclaimedQty + row.claimedQty,
        reason: ''
      }
      this.adjustQuantityDialog = true
    },

    // 确认调整数量
    confirmAdjustQuantity() {
      this.$refs.adjustQuantityForm.validate(valid => {
        if (valid) {
          this.adjustQuantityLoading = true
          const params = {
            newQuantity: this.adjustQuantityForm.newQuantity,
            reason: this.adjustQuantityForm.reason
          }

          mixedPackageApi.adjustClaimQuantity(this.adjustQuantityForm.claimId, params).then(res => {
            if (res.code === 200 || res.code === '200') {
              this.$message.success('Quantity adjusted successfully')
              this.adjustQuantityDialog = false
              this.getClaimList()
              this.refreshPendingCount()
            } else {
              this.$message.error(res.message || 'Adjust failed')
            }
            this.adjustQuantityLoading = false
          }).catch(err => {
            this.$message.error(err.message || 'Adjust failed')
            this.adjustQuantityLoading = false
          })
        }
      })
    },

    // 显示拒绝认领对话框
    showRejectClaim(row) {
      this.rejectClaimForm = {
        claimId: row.claimId,
        reason: ''
      }
      this.rejectClaimDialog = true
    },

    // 确认拒绝认领
    confirmRejectClaim() {
      this.$refs.rejectClaimForm.validate(valid => {
        if (valid) {
          this.rejectClaimLoading = true
          const params = {
            reason: this.rejectClaimForm.reason
          }

          mixedPackageApi.rejectClaim(this.rejectClaimForm.claimId, params).then(res => {
            if (res.code === 200 || res.code === '200') {
              this.$message.success('Claim rejected successfully')
              this.rejectClaimDialog = false
              this.getClaimList()
              this.refreshPendingCount()
            } else {
              this.$message.error(res.message || 'Reject failed')
            }
            this.rejectClaimLoading = false
          }).catch(err => {
            this.$message.error(err.message || 'Reject failed')
            this.rejectClaimLoading = false
          })
        }
      })
    },

    // 显示批量批准对话框
    showBatchApprove() {
      if (this.approvableClaimsCount === 0) {
        this.$message.warning('Please select claims with "Pending Review" status to approve')
        return
      }

      // 检查是否有非Pending Review状态的选中项
      const invalidClaims = this.selectedClaims.filter(claim => claim.claimStatus !== 0)

      if (invalidClaims.length > 0) {
        this.$message.warning(`${invalidClaims.length} selected claims cannot be approved (only "Pending Review" claims can be approved). Please adjust your selection.`)
        return
      }

      const message = `Are you sure to approve ${this.approvableClaimsCount} selected claims?

All selected claims are in "Pending Review" status and will be changed to "Approved" status.

This action cannot be undone.`

      this.$confirm(message, 'Batch Approve Confirmation', {
        type: 'warning',
        confirmButtonText: 'Yes, Approve All',
        cancelButtonText: 'Cancel'
      }).then(() => {
        this.confirmBatchApprove()
      })
    },

    // 执行批量批准
    async confirmBatchApprove() {
      const loading = this.$loading({
        lock: true,
        text: `Approving ${this.approvableClaimsCount} claims...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let successCount = 0
      let failCount = 0
      const failedItems = []

      try {
        // 串行处理每个批准操作
        for (const claim of this.approvableClaims) {
          try {
            const res = await mixedPackageApi.approveClaim(claim.claimId)

            if (res.code === 200 || res.code === '200') {
              successCount++
            } else {
              failCount++
              failedItems.push({
                tracking: claim.tracking,
                upc: claim.upc,
                error: res.message || 'Unknown error'
              })
            }
          } catch (error) {
            failCount++
            failedItems.push({
              tracking: claim.tracking,
              upc: claim.upc,
              error: error.message || 'Network error'
            })
          }

          // 短暂延迟避免服务器压力
          if (this.approvableClaims.length > 1) {
            await new Promise(resolve => setTimeout(resolve, 200))
          }
        }
      } finally {
        loading.close()
      }

      // 刷新列表和清除选中状态
      this.getClaimList()
      this.refreshPendingCount()
      this.$refs.claimTable && this.$refs.claimTable.clearSelection()

      // 显示结果
      if (failCount === 0) {
        this.$message.success(`All ${successCount} claims approved successfully!`)
      } else if (successCount === 0) {
        this.$message.error(`All ${failCount} approvals failed.`)
        this.showBatchOperationErrors(failedItems, 'Approval Errors')
      } else {
        this.$message.warning(`${successCount} claims approved, ${failCount} failed.`)
        this.showBatchOperationErrors(failedItems, 'Partial Approval Results')
      }
    },

    // 显示批量拒绝对话框
    showBatchReject() {
      if (this.rejectableClaimsCount === 0) {
        this.$message.warning('Please select claims with "Pending Review", "Approved", or "Quantity Adjusted" status to reject')
        return
      }

      // 检查是否有不能拒绝的选中项
      const invalidClaims = this.selectedClaims.filter(claim =>
        claim.claimStatus !== 0 && claim.claimStatus !== 1 && claim.claimStatus !== 4
      )

      if (invalidClaims.length > 0) {
        this.$message.warning(`${invalidClaims.length} selected claims cannot be rejected (only "Pending Review", "Approved", or "Quantity Adjusted" claims can be rejected). Please adjust your selection.`)
        return
      }

      // 显示批量拒绝确认对话框
      const message = `Are you sure to reject ${this.rejectableClaimsCount} selected claims?

This will change all selected claims to "Rejected" status and they cannot be processed further.

This action cannot be undone. Please provide a reason for rejection.`

      this.$prompt(message, 'Batch Reject Confirmation', {
        confirmButtonText: 'Yes, Reject All',
        cancelButtonText: 'Cancel',
        inputType: 'textarea',
        inputPlaceholder: 'Please enter the reason for rejection...',
        inputValidator: (value) => {
          if (!value || value.trim().length === 0) {
            return 'Rejection reason is required'
          }
          if (value.trim().length < 5) {
            return 'Rejection reason must be at least 5 characters'
          }
          return true
        }
      }).then(({ value }) => {
        this.confirmBatchReject(value.trim())
      }).catch(() => {
        // User cancelled batch reject
      })
    },

    // 执行批量拒绝
    async confirmBatchReject(reason) {
      const loading = this.$loading({
        lock: true,
        text: `Rejecting ${this.rejectableClaimsCount} claims...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let successCount = 0
      let failCount = 0
      const failedItems = []

      try {
        // 串行处理每个拒绝操作
        for (const claim of this.rejectableClaims) {
          try {
            const params = { reason: reason }
            const res = await mixedPackageApi.rejectClaim(claim.claimId, params)

            if (res.code === 200 || res.code === '200') {
              successCount++
            } else {
              failCount++
              failedItems.push({
                tracking: claim.tracking,
                upc: claim.upc,
                error: res.message || 'Unknown error'
              })
            }
          } catch (error) {
            failCount++
            failedItems.push({
              tracking: claim.tracking,
              upc: claim.upc,
              error: error.message || 'Network error'
            })
          }

          // 短暂延迟避免服务器压力
          if (this.rejectableClaims.length > 1) {
            await new Promise(resolve => setTimeout(resolve, 200))
          }
        }
      } finally {
        loading.close()
      }

      // 刷新列表和清除选中状态
      this.getClaimList()
      this.refreshPendingCount()
      this.$refs.claimTable && this.$refs.claimTable.clearSelection()

      // 显示结果
      if (failCount === 0) {
        this.$message.success(`All ${successCount} claims rejected successfully!`)
      } else if (successCount === 0) {
        this.$message.error(`All ${failCount} rejections failed.`)
        this.showBatchOperationErrors(failedItems, 'Rejection Errors')
      } else {
        this.$message.warning(`${successCount} claims rejected, ${failCount} failed.`)
        this.showBatchOperationErrors(failedItems, 'Partial Rejection Results')
      }
    },

    // 显示批量下发对话框
    showBatchDistribute() {
      if (this.distributableClaimsCount === 0) {
        this.$message.warning('Please select claims with "Approved" or "Quantity Adjusted" status to distribute')
        return
      }

      // 检查是否有不能下发的选中项
      const invalidClaims = this.selectedClaims.filter(claim =>
        claim.claimStatus !== 1 && claim.claimStatus !== 4
      )

      if (invalidClaims.length > 0) {
        this.$message.warning(`${invalidClaims.length} selected claims cannot be distributed (only "Approved" or "Quantity Adjusted" claims can be distributed). Please adjust your selection.`)
        return
      }

      // 为每个claim初始化可编辑的收费时间
      this.selectedClaims.forEach(claim => {
        // 如果已经有强制收费时间，使用现有的；否则设置为null（表示使用正常免费期）
        this.$set(claim, 'editableChargeTime', claim.forceChargeTime || null)
      })

      // 重置批量设置表单
      this.batchDistributeForm = {
        chargeTimeOption: '',
        customChargeTime: null
      }

      this.batchDistributeDialog = true
    },

    // 确认批量下发
    confirmBatchDistribute() {
      this.batchDistributeLoading = true

      // 直接使用个别设置模式（因为用户已通过Apply按钮设置了表格中的值）
      this.confirmIndividualBatchDistribute()
    },

    // 确认个别设置批量下发
    confirmIndividualBatchDistribute() {
      // 构建每个claim的请求参数，支持独立的收费时间设置
      const claimRequests = this.distributableClaims.map(claim => {
        const request = {
          claimId: claim.claimId
        }

        // 如果设置了editableChargeTime，则使用它作为强制收费时间
        if (claim.editableChargeTime) {
          request.forceChargeTime = claim.editableChargeTime
        }

        return request
      })

      // 调用批量下发API，传递每个claim的独立设置
      const params = {
        claimRequests: claimRequests
      }

      mixedPackageApi.batchDistributeWithIndividualSettings(params).then(res => {
        if (res.code === 200 || res.code === '200') {
          // 只有在成功响应且result存在时才调用结果处理
          if (res.result && typeof res.result === 'object') {
            this.handleBatchDistributeResult(res.result)
          } else {
            console.error('Success response but invalid result:', res.result, 'Full response:', res)
            this.showFormattedError('Batch distribute failed: Invalid response data', 'Batch Distribute Failed')
          }
        } else {
          this.showFormattedError(res.message || 'Batch distribute failed', 'Batch Distribute Failed')
        }
        this.batchDistributeLoading = false
      }).catch(err => {
        // 如果新API不存在，回退到原有的统一设置方式
        if (err.message && err.message.includes('404')) {
          this.fallbackToBatchDistribute()
        } else {
          this.showFormattedError(err.message || 'Batch distribute failed', 'Batch Distribute Error')
          this.batchDistributeLoading = false
        }
      })
    },

    // 处理批量下发结果
    handleBatchDistributeResult(result) {

      // 安全检查，确保result对象存在且包含必要属性
      if (!result || typeof result !== 'object') {
        console.error('Invalid result object:', result)
        this.$message.error('Batch distribute failed: Invalid response format')
        this.batchDistributeLoading = false
        return
      }

      const {
        total = 0,
        success = 0,
        failed = 0,
        successResults = [],
        failedResults = [],
        message = ''
      } = result


      // 构建结果消息
      let resultMsg = ''
      let messageType = 'success'

      if (failed === 0) {
        // 全部成功
        resultMsg = `批量下发成功完成！\n总计: ${total} 条，全部成功`
        messageType = 'success'
      } else if (success === 0) {
        // 全部失败
        resultMsg = `批量下发失败！\n总计: ${total} 条，全部失败\n\n失败详情:\n`
        failedResults.forEach((failure, index) => {
          let cleanedFailure = this.formatFailureMessage(failure)
          resultMsg += `${index + 1}. ${cleanedFailure}\n`
        })
        messageType = 'error'
      } else {
        // 部分成功
        resultMsg = `批量下发完成！\n总计: ${total} 条，成功: ${success} 条，失败: ${failed} 条\n\n`

        if (failed > 0) {
          resultMsg += '失败详情:\n'
          failedResults.forEach((failure, index) => {
            let cleanedFailure = this.formatFailureMessage(failure)
            resultMsg += `${index + 1}. ${cleanedFailure}\n`
          })
        }
        messageType = 'warning'
      }

      // 显示结果弹窗，用户关闭后自动关闭窗口并刷新列表
      const alertType = messageType === 'warning' ? 'warning' : (messageType === 'error' ? 'error' : 'success')
      const htmlMessage = resultMsg.replace(/\n/g, '<br>')

      this.$alert(htmlMessage, '批量下发结果', {
        dangerouslyUseHTMLString: true,
        type: alertType,
        confirmButtonText: '确定',
        callback: () => {
          // 用户点击确定或关闭弹窗时，关闭窗口并刷新列表
          this.batchDistributeDialog = false
          this.getClaimList()
          this.$refs.claimTable && this.$refs.claimTable.clearSelection()
        }
      })
    },


    // 格式化失败消息，清理重复信息并优化显示
    formatFailureMessage(failure) {
      if (!failure || typeof failure !== 'string') {
        return failure || '未知错误'
      }

      // 新格式的错误消息已经由后端优化过，直接返回
      if (failure.includes('快递单号:') && failure.includes('失败原因:')) {
        return failure
      }

      // 处理旧格式的错误消息，清理重复信息
      let cleanedMessage = failure

      // 移除开头的UPC重复信息
      cleanedMessage = cleanedMessage.replace(/^UPC\s*[^:：\s]*\s*[：:]*\s*/, '')

      // 移除"下发失败:"等冗余前缀
      cleanedMessage = cleanedMessage.replace(/下发失败[：:]*\s*/, '')

      // 移除多余的标点符号和空白
      cleanedMessage = cleanedMessage.replace(/^[：:\s,，]+|[：:\s,，]+$/g, '').trim()

      // 如果消息为空，返回通用错误消息
      if (!cleanedMessage) {
        cleanedMessage = '下发失败'
      }

      return cleanedMessage
    },

    // 回退到原有的批量下发方式（兼容性处理）
    fallbackToBatchDistribute() {
      const params = {
        claimIds: this.distributableClaims.map(claim => claim.claimId).join(',')
      }

      mixedPackageApi.batchDistribute(params).then(res => {
        if (res.code === 200 || res.code === '200') {
          this.$message.success('Batch distribute completed successfully')
          this.batchDistributeDialog = false
          this.getClaimList()
          this.$refs.claimTable && this.$refs.claimTable.clearSelection()
        } else {
          this.showFormattedError(res.message || 'Batch distribute failed', 'Batch Distribute Failed')
        }
        this.batchDistributeLoading = false
      }).catch(err => {
        this.showFormattedError(err.message || 'Batch distribute failed', 'Batch Distribute Error')
        this.batchDistributeLoading = false
      })
    },

    // 显示设置收费时间对话框
    showSetChargeTime() {
      if (this.chargeEditableClaimsCount === 0) {
        this.$message.warning('Please select claims with "Approved" or "Quantity Adjusted" status to set charge time')
        return
      }

      // 检查是否有不能编辑收费时间的选中项
      const invalidClaims = this.selectedClaims.filter(claim =>
        claim.claimStatus !== 1 && claim.claimStatus !== 4
      )

      if (invalidClaims.length > 0) {
        this.$message.warning(`${invalidClaims.length} selected claims cannot have their charge time modified (only "Approved" or "Quantity Adjusted" claims can be edited). Please adjust your selection.`)
        return
      }

      // 为每个claim初始化可编辑的收费时间
      this.chargeEditableClaims.forEach(claim => {
        // 如果已经有强制收费时间，使用现有的；否则设置为null（表示使用正常免费期）
        this.$set(claim, 'editableChargeTime', claim.forceChargeTime || null)
      })

      // 重置批量设置表单
      this.setChargeTimeForm = {
        chargeTimeOption: '',
        customChargeTime: null
      }

      this.setChargeTimeDialog = true
    },

    // 应用批量收费时间设置到Batch Distribute表格
    applyBatchChargeTime() {
      let chargeTime = null
      if (this.batchDistributeForm.chargeTimeOption === 'immediate') {
        chargeTime = new Date().toISOString().slice(0, 19).replace('T', ' ')
      } else if (this.batchDistributeForm.chargeTimeOption === 'custom') {
        chargeTime = this.batchDistributeForm.customChargeTime
      }
      // normal情况下chargeTime保持为null

      // 应用到所有选中的claims
      this.selectedClaims.forEach(claim => {
        this.$set(claim, 'editableChargeTime', chargeTime)
      })

      this.$message.success(`Applied batch setting to ${this.selectedClaims.length} claims`)
    },

    // 应用批量收费时间设置到Set Force Charge Time表格
    applyBatchChargeTimeSetting() {
      let chargeTime = null
      if (this.setChargeTimeForm.chargeTimeOption === 'immediate') {
        chargeTime = new Date().toISOString().slice(0, 19).replace('T', ' ')
      } else if (this.setChargeTimeForm.chargeTimeOption === 'custom') {
        chargeTime = this.setChargeTimeForm.customChargeTime
      }
      // normal情况下chargeTime保持为null

      // 应用到所有可编辑的claims
      this.chargeEditableClaims.forEach(claim => {
        this.$set(claim, 'editableChargeTime', chargeTime)
      })

      this.$message.success(`Applied batch setting to ${this.chargeEditableClaims.length} claims`)
    },

    // 确认设置收费时间
    confirmSetChargeTime() {
      this.setChargeTimeLoading = true

      // 直接使用个别设置模式（因为用户已通过Apply按钮设置了表格中的值）
      this.confirmIndividualSetChargeTime()
    },

    // 确认个别设置收费时间
    confirmIndividualSetChargeTime() {
      // 构建每个claim的请求参数，支持独立的收费时间设置
      const claimRequests = this.chargeEditableClaims.map(claim => {
        const request = {
          claimId: claim.claimId,
          forceChargeTime: claim.editableChargeTime || null
        }
        return request
      })

      // 调用设置收费时间API，传递每个claim的独立设置
      const params = {
        claimRequests: claimRequests
      }

      mixedPackageApi.setForceChargeTimeWithIndividualSettings(params).then(res => {
        if (res.code === 200 || res.code === '200') {
          this.$message.success('Charge time setting completed successfully')
          this.setChargeTimeDialog = false
          this.getClaimList()
        } else {
          this.$message.error(res.message || 'Set charge time failed')
        }
        this.setChargeTimeLoading = false
      }).catch(err => {
        // 如果新API不存在，回退到原有的统一设置方式
        if (err.message && err.message.includes('404')) {
          this.fallbackToSetChargeTime()
        } else {
          this.$message.error(err.message || 'Set charge time failed')
          this.setChargeTimeLoading = false
        }
      })
    },


    // 回退到原有的设置收费时间方式（兼容性处理）
    fallbackToSetChargeTime() {
      const params = {
        claimIds: this.editableClaimIds.join(','),
        forceChargeTime: null // 回退时使用null，表示恢复正常免费期
      }

      mixedPackageApi.setForceChargeTime(params).then(res => {
        if (res.code === 200 || res.code === '200') {
          this.$message.success('Charge time setting completed successfully')
          this.setChargeTimeDialog = false
          this.getClaimList()
        } else {
          this.$message.error(res.message || 'Set charge time failed')
        }
        this.setChargeTimeLoading = false
      }).catch(err => {
        this.$message.error(err.message || 'Set charge time failed')
        this.setChargeTimeLoading = false
      })
    },

    // 回滚认领记录到待审核状态
    async rollbackClaimToPending(claim) {
      try {
        // 确认对话框
        await this.$confirm(
          `Are you sure to rollback this claim to pending status?

Tracking: ${claim.tracking}
UPC: ${claim.upc}
Claimer: ${claim.claimerName}
Current Status: ${claim.claimStatusDesc}

This action will reset the claim back to pending review status, allowing warehouse administrators to re-process, adjust quantities, or reject the claim.

This action cannot be undone.`,
          'Confirm Rollback',
          {
            confirmButtonText: 'Yes, Rollback',
            cancelButtonText: 'Cancel',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        )

        // 调用后端API进行回滚
        const response = await mixedPackageApi.rollbackClaimToPending(claim.claimId)

        if (response && (response.code === 200 || response.code === '200')) {
          this.$message.success('Claim rolled back to pending status successfully')
          // 刷新认领列表
          this.getClaimList()
          // 刷新待审核数量统计
          this.refreshPendingCount()
        } else {
          this.$message.error(response.msg || response.message || 'Rollback failed')
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Rollback error: ' + (error.message || error))
        }
      }
    },

    // 查看认领详情
    viewClaimDetail(row) {
      this.claimDetail = row
      this.claimDetailDialog = true
    },

    // 关闭认领详情对话框
    onClaimDetailClose() {
      this.claimDetail = null
    },

    // 数量标签类型
    getQuantityTagType(row) {
      if (row.claimedQty > row.totalQty) {
        return 'danger'
      } else if (row.claimedQty > row.unclaimedQty) {
        return 'warning'
      }
      return 'success'
    },

    // 显示批量操作错误详情
    showBatchOperationErrors(failedItems, title = 'Operation Errors') {
      if (!failedItems || failedItems.length === 0) return

      // 构建错误详情内容
      let content = `<div style="text-align: left; max-height: 400px; overflow-y: auto;">`
      content += `<h4>Failed Items (${failedItems.length}):</h4>`
      content += `<div style="font-family: monospace; font-size: 12px; background: #f5f5f5; padding: 10px; border-radius: 4px;">`

      failedItems.forEach((item, index) => {
        content += `${index + 1}. Tracking: ${item.tracking} | UPC: ${item.upc}<br>`
        content += `&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #E6A23C;">Error: ${item.error}</span><br><br>`
      })

      content += `</div></div>`

      // 使用MessageBox显示
      this.$msgbox({
        title: title,
        message: content,
        type: 'error',
        dangerouslyUseHTMLString: true,
        showClose: true,
        closeOnClickModal: true,
        confirmButtonText: 'OK'
      }).catch(() => {
        // 用户关闭对话框
      })
    },

    // 获取认领状态标签类型
    getClaimStatusTagType(status) {
      const statusMap = {
        0: 'warning',    // Pending Review - 黄色
        1: 'success',    // Approved - 绿色
        2: 'info',       // Distributed - 蓝色
        3: 'danger',     // Rejected - 红色
        4: 'primary'     // Quantity Adjusted - 紫色
      }
      return statusMap[status] || 'info'
    },

    // 获取认领状态文本
    getClaimStatusText(status) {
      const statusMap = {
        0: 'Pending Review',
        1: 'Approved',
        2: 'Distributed',
        3: 'Rejected',
        4: 'Quantity Adjusted'
      }
      return statusMap[status] || 'Unknown'
    },

    // ==================== Bulk Confirm Result 相关方法 ====================

    // 格式化错误信息
    formatErrorMessage(error) {
      if (!error) return null

      let errorMessage = ''

      // 如果error是字符串，直接使用
      if (typeof error === 'string') {
        errorMessage = error
      } else if (typeof error === 'object') {
        // 如果error是对象，尝试提取消息
        errorMessage = error.message || error.msg || error.error || JSON.stringify(error)
      } else {
        errorMessage = String(error)
      }

      // 智能识别和转换常见的错误信息
      return this.translateErrorMessage(errorMessage)
    },

    // 翻译和优化错误信息
    translateErrorMessage(errorMessage) {
      if (!errorMessage) return 'Unknown error'

      // 检查是否是系统繁忙的通用错误，但实际上可能是重复tracking
      if (errorMessage.includes('系统繁忙，请稍后重试')) {
        // 对于系统繁忙错误，根据上下文推断可能的原因
        return '操作失败：可能是tracking号重复或系统繁忙，请检查该tracking是否已存在'
      }

      // 重复tracking错误的各种形式
      if (errorMessage.includes('Duplicate entry') && errorMessage.includes('uk_tracking')) {
        return '快递单号已存在，请确认后重试'
      }

      if (errorMessage.includes('duplicate tracking') ||
          errorMessage.includes('tracking number already exists') ||
          errorMessage.includes('快递单号已存在')) {
        return '快递单号已存在，请确认后重试'
      }

      // 数据库约束违反
      if (errorMessage.includes('MySQLIntegrityConstraintViolationException')) {
        return '数据完整性约束违反：可能是重复数据或关联数据缺失'
      }

      // 网络或连接错误
      if (errorMessage.includes('Network Error') ||
          errorMessage.includes('timeout') ||
          errorMessage.includes('connection')) {
        return '网络连接错误，请稍后重试'
      }

      // 权限错误
      if (errorMessage.includes('unauthorized') ||
          errorMessage.includes('permission') ||
          errorMessage.includes('权限')) {
        return '权限不足，请联系管理员'
      }

      // 返回原始错误信息（截取前150个字符避免过长）
      return errorMessage.length > 150 ? errorMessage.substring(0, 150) + '...' : errorMessage
    },

    // 判断错误是否可重试
    determineCanRetry(errorMessage) {
      if (!errorMessage) return false

      // 先格式化错误信息以获得智能翻译
      const formattedError = this.translateErrorMessage(errorMessage)

      // 重复tracking number不可重试（检查格式化后的信息）
      if (formattedError.includes('快递单号已存在') ||
          formattedError.includes('tracking number already exists') ||
          formattedError.includes('duplicate tracking') ||
          formattedError.includes('tracking号重复')) {
        return false
      }

      // 数据完整性约束违反通常不可重试
      if (formattedError.includes('数据完整性约束违反')) {
        return false
      }

      // 权限错误不可重试
      if (formattedError.includes('权限不足')) {
        return false
      }

      // 网络错误和系统繁忙（非重复原因）可以重试
      return true
    },

    // 获取包裹商品数量
    getPackageItemCount(tracking) {
      const packageRecord = this.selectedPackages.find(p => p.tracking === tracking)
      return packageRecord ? packageRecord.itemCount : 0
    },

    // 处理批量确认结果对话框事件
    handleBulkConfirmContinue(result) {
      if (result.successCount > 0) {
        this.$message.success(`${result.successCount} package(s) confirmed successfully!`)
      }
    },

    handleBulkConfirmRetryFailed(retryData) {
      // 构建重试的包裹列表
      const retryPackages = retryData.failedRecords.map(failedRecord => {
        return this.selectedPackages.find(p => p.tracking === failedRecord.tracking)
      }).filter(Boolean)

      if (retryPackages.length === 0) {
        this.$message.warning('No packages found for retry')
        return
      }

      // 设置重试的包裹并显示确认对话框
      this.selectedPackages = retryPackages
      this.bulkConfirmResultDialogVisible = false
      this.bulkConfirmDialogVisible = true

      this.$message.info(`Loaded ${retryPackages.length} failed package(s) for retry. Please review and confirm again.`)
    },

    handleBulkConfirmResultClose() {
      this.bulkConfirmResultDialogVisible = false

      // 清除选中的包裹
      this.selectedPackages = []
    },

    // 显示格式化的错误消息
    showFormattedError(errorMessage, title = 'Error') {
      if (!errorMessage) return

      // 将换行符转换为HTML的<br>标签
      const htmlMessage = errorMessage.replace(/\n/g, '<br>')

      this.$alert(htmlMessage, title, {
        dangerouslyUseHTMLString: true,
        type: 'error',
        confirmButtonText: '确定'
      })
    }
  },

  computed: {
    packageInfoRows() {
      if (!this.currentPackageDetail) return []

      return [
        {
          label1: 'Package ID:',
          value1: this.currentPackageDetail.mixedPackageId,
          label2: 'Tracking Number:',
          value2: this.currentPackageDetail.tracking,
          label3: 'Warehouse:',
          value3: this.currentPackageDetail.warehouseName || this.currentPackageDetail.warehouse
        },
        {
          label1: 'Status:',
          value1: this.getStatusText(this.currentPackageDetail.packageStatus),
          label2: 'Total UPC Items:',
          value2: this.currentPackageDetail.totalItems,
          label3: 'Claims:',
          value3: this.currentPackageDetail.claimedItems
        },
        {
          label1: 'Create Date:',
          value1: this.formatDate(this.currentPackageDetail.createDate),
          label2: '',
          value2: '',
          label3: '',
          value3: ''
        }
      ]
    },

    // 可批量批准的记录（只有Pending Review状态）
    approvableClaims() {
      return this.selectedClaims.filter(claim => claim.claimStatus === 0)
    },

    approvableClaimsCount() {
      return this.approvableClaims.length
    },

    canBatchApprove() {
      return this.approvableClaimsCount > 0
    },

    // 可批量拒绝的记录（Pending Review, Approved, Quantity Adjusted状态）
    rejectableClaims() {
      return this.selectedClaims.filter(claim =>
        claim.claimStatus === 0 || claim.claimStatus === 1 || claim.claimStatus === 4
      )
    },

    rejectableClaimsCount() {
      return this.rejectableClaims.length
    },

    canBatchReject() {
      return this.rejectableClaimsCount > 0
    },

    // 可批量下发的记录（已批准或数量已调整状态）
    distributableClaims() {
      return this.selectedClaims.filter(claim =>
        claim.claimStatus === 1 || claim.claimStatus === 4
      )
    },

    distributableClaimsCount() {
      return this.distributableClaims.length
    },

    canBatchDistribute() {
      return this.distributableClaimsCount > 0
    },

    // 可编辑收费时间的认领记录（已批准或数量已调整状态）
    chargeEditableClaims() {
      return this.selectedClaims.filter(claim =>
        claim.claimStatus === 1 || claim.claimStatus === 4
      )
    },

    chargeEditableClaimsCount() {
      return this.chargeEditableClaims.length
    },

    canSetForceChargeTime() {
      return this.chargeEditableClaimsCount > 0
    },

    // 保持向后兼容（遗留属性）
    editableClaimIds() {
      return this.chargeEditableClaims.map(claim => claim.claimId)
    },

    editableClaims() {
      return this.chargeEditableClaims
    }
  }
}
</script>

<style scoped>
.toolbar {
  background: #f2f6fc;
  padding: 10px;
  margin: 10px 0px;
}

/* 批次号下拉框样式优化 */
.el-select-dropdown__item {
  padding: 8px 12px !important;
  line-height: 1.5;
}

.batch-option-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 4px 0;
}

.batch-number {
  font-weight: 500;
  color: #303133;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 12px;
}

.batch-pending-count {
  color: #909399;
  font-size: 12px;
  flex-shrink: 0;
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #e4e7ed;
}

.batch-package-count {
  color: #909399;
  font-size: 12px;
  flex-shrink: 0;
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #e4e7ed;
}

/* hover 效果优化 */
.el-select-dropdown__item:hover .batch-pending-count,
.el-select-dropdown__item:hover .batch-package-count {
  background: #e6f3ff;
  border-color: #c6e2ff;
  color: #409eff;
}

/* 批次号显示样式 */
.batch-number-display {
  margin: 4px 0 0 0;
  font-size: 11px;
}

.batch-number-display .el-tag {
  font-size: 11px;
  padding: 0 6px;
  height: 20px;
  line-height: 18px;
}

.toolbar .el-form-item {
  margin-bottom: 10px;
}

.note {
  color: #909399;
  font-size: 12px;
  margin: 2px 0;
}

.text-warning {
  color: #e6a23c;
  font-weight: bold;
}

/* Tab样式优化 */
.el-tabs__item {
  font-weight: bold;
}

.el-tabs__nav-wrap::after {
  background-color: #e4e7ed;
}

/* 表格样式优化 */
.el-table {
  font-size: 13px;
}

.el-table .cell {
  line-height: 1.4;
}

/* 按钮组样式 */
.el-button + .el-button {
  margin-left: 8px;
}

/* 状态标签样式 */
.el-tag {
  font-weight: bold;
}

/* ===================== 认领相关样式 ===================== */

/* 负数量警告动画 */
.negative-quantity-alert {
  animation: blink 1.5s linear infinite;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
}

/* 收费时间显示样式 */
.charge-time-display {
  font-size: 12px;
}

.charge-time-forced {
  color: #E6A23C;
  font-weight: 600;
}

.charge-time-normal {
  color: #909399;
}

/* 认领详情对话框样式 */
.claim-detail-descriptions {
  margin: 20px 0;
}

.claim-label {
  background-color: #f5f7fa !important;
  font-weight: 600;
}

.product-name-container {
  max-width: 300px;
}

.product-name-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
}

/* El-badge 样式调整 */
.el-badge {
  line-height: 1;
}

.item .el-badge__content {
  background-color: #f56c6c;
  border: 1px solid #f56c6c;
}

/* 强制收费时间相关样式 */
.force-charge-time {
  color: #E6A23C;
  font-weight: 600;
  font-size: 12px;
}

.no-force-charge {
  color: #C0C4CC;
  font-size: 12px;
}

/* 信息展示区域样式 */
.info-section {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.info-section h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-weight: 600;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-item {
  flex: 1;
  min-width: 0;
}

.info-label {
  font-weight: 600;
  color: #606266;
  margin-right: 8px;
}

.info-value {
  color: #303133;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .info-row {
    flex-direction: column;
  }

  .info-item {
    margin-bottom: 5px;
  }
}

/* 对话框样式 */
.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 10px;
}

/* 导入提示样式 */
.import-hint {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.import-hint i {
  margin-right: 4px;
}

/* hover帮助图标 */
.hover-help-icon {
  color: #909399;
  cursor: pointer;
  font-size: 14px;
  margin-left: 8px;
}

.hover-help-icon:hover {
  color: #409EFF;
}

/* Tooltip内容样式 */
.tooltip-format-guide {
  max-width: 400px;
  line-height: 1.6;
}

.tooltip-format-guide strong {
  color: #FFFFFF;
}

.tooltip-example {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 8px;
  margin-top: 5px;
  font-family: 'Courier New', Consolas, monospace;
  font-size: 11px;
  line-height: 1.4;
  color: #E6A23C;
  word-break: break-all;
}

/* 批次摘要卡片样式 */
.batch-summary-card {
  margin-bottom: 20px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

.summary-item .label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.summary-item .value {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

/* 错误和成功消息样式 */
.error-message {
  color: #f56c6c;
  font-size: 12px;
}

.success-message {
  color: #67c23a;
  font-size: 12px;
}

/* 上传区域样式 */
.el-upload {
  width: 100%;
}

.el-upload-dragger {
  width: 100%;
}

/* 只读输入框样式 */
.readonly-input {
  background-color: #f5f7fa;
}

.readonly-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 包裹信息展示样式 */
.info-label {
  font-weight: bold;
  color: #606266;
  font-size: 13px;
  margin-bottom: 4px;
}

.info-value {
  color: #303133;
  font-size: 14px;
  min-height: 20px;
}

/* 包裹信息表格样式 */
.info-label-cell {
  background-color: #f5f7fa !important;
  font-weight: bold;
  color: #606266;
}

.info-value-cell {
  background-color: #ffffff;
}

.readonly-hint i {
  margin-right: 4px;
}

/* 强制收费时间样式 */
.force-charge-time {
  color: #f56c6c;
  font-weight: bold;
  font-size: 12px;
}

.no-force-charge {
  color: #c0c4cc;
  font-size: 12px;
}

/* 表单验证增强 */
.el-form-item__error {
  position: static;
  margin-top: 2px;
}

/* 对话框内表格样式 */
.dialog-footer .el-table {
  margin-top: 15px;
}

.dialog-footer .el-table .el-table__header {
  background-color: #f8f9fa;
}

/* 信息项样式增强 */
.info-item {
  margin-bottom: 8px;
}

.info-item .label {
  font-weight: 500;
  color: #606266;
}

.info-item .value {
  color: #303133;
  font-weight: 600;
}

/* 库存下发时间显示样式 */
.distribute-date {
  display: flex;
  align-items: center;
  color: #67C23A;
  font-size: 12px;
}

.distribute-date .el-icon-box {
  margin-right: 4px;
  color: #67C23A;
}

/* Tracking相关样式 */
.tracking-list-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.tracking-simple {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tracking-with-more {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.tracking-tag {
  margin: 0 !important;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 11px;
  max-width: 160px;
}

.tracking-tag:hover {
  transform: scale(1.05);
  z-index: 10;
}

.tracking-more-tag {
  margin: 0 !important;
  cursor: pointer;
  font-weight: bold;
}

/* 弹窗内容样式 */
.tracking-popover {
  max-height: 300px;
  overflow-y: auto;
}

.popover-title {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 14px;
}

.tracking-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 6px;
}

.tracking-tag-full {
  margin: 0 !important;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 11px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .el-table {
    font-size: 12px;
  }

  .el-button {
    padding: 5px 10px;
    font-size: 12px;
  }

  .toolbar .el-form-item {
    margin-right: 5px;
  }

  /* 对话框在小屏幕上的适配 */
  .el-dialog {
    width: 95% !important;
    margin-top: 5vh !important;
  }

  .info-item {
    margin-bottom: 10px;
  }

  .info-item .label {
    display: block;
    margin-bottom: 2px;
  }
}

/* ===================== Package Detail & Management 对话框简洁优化 ===================== */
.package-detail-dialog {
  .el-dialog {
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  }

  .el-dialog__header {
    background: #4f46e5;
    padding: 20px 24px;
    color: white;
  }

  .el-dialog__title {
    color: white;
    font-weight: 600;
    font-size: 18px;
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 24px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: white;
    font-size: 18px;
  }

  .el-dialog__body {
    padding: 24px;
    background: #ffffff;
  }

  /* 包裹信息卡片 - 简洁版 */
  .batch-summary-card {
    margin-bottom: 20px;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
  }

  .batch-summary-card .el-card__header {
    background: #f8fafc;
    padding: 16px 20px;
    border-bottom: 1px solid #e5e7eb;
  }

  .batch-summary-card .clearfix {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .batch-summary-card .header-title {
    color: #374151;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  .batch-summary-card .header-title i {
    margin-right: 8px;
    font-size: 16px;
    color: #6b7280;
  }

  .batch-summary-card .header-actions .el-button {
    font-size: 13px !important;
    padding: 6px 12px !important;
  }

  .batch-summary-card .el-card__body {
    padding: 20px;
    background: #ffffff;
  }

  .batch-summary-card .summary-item {
    margin-bottom: 16px;
  }

  .batch-summary-card .summary-item .label {
    display: block;
    font-size: 14px !important;
    color: #6b7280 !important;
    margin-bottom: 6px !important;
    font-weight: 500 !important;
  }

  .batch-summary-card .summary-item .value {
    font-size: 15px !important;
    color: #374151 !important;
    font-weight: 600 !important;
  }

  .batch-summary-card .summary-item .tracking-code {
    font-family: 'Monaco', 'Consolas', monospace !important;
    background: #f3f4f6 !important;
    color: #374151 !important;
    padding: 8px 12px !important;
    border-radius: 4px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    letter-spacing: 0.5px !important;
    border: 1px solid #d1d5db !important;
  }

  .batch-summary-card .el-tag {
    font-size: 12px !important;
    padding: 4px 8px !important;
    font-weight: 500 !important;
  }

  /* UPC Items表格 - 简洁版 */
  .items-card {
    border-radius: 6px;
    border: 1px solid #e5e7eb;
  }

  .items-card .el-card__header {
    background: #f8fafc;
    padding: 16px 20px;
    border-bottom: 1px solid #e5e7eb;
  }

  .items-card .clearfix {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .items-card .header-title {
    color: #374151;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  .items-card .header-title i {
    margin-right: 8px;
    font-size: 16px;
    color: #6b7280;
  }

  .items-card .header-actions {
    display: flex;
    gap: 8px;
  }

  .items-card .header-actions .el-button {
    font-size: 13px !important;
    padding: 6px 12px !important;
  }

  .items-card .el-card__body {
    padding: 0;
    background: #ffffff;
  }

  /* 表格样式 - 简洁版但保持易读性 */
  .items-card .el-table {
    font-size: 14px !important;
    border: none;
  }

  .items-card .el-table th {
    background: #f8fafc !important;
    color: #374151 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    padding: 16px 12px !important;
    border-bottom: 1px solid #e5e7eb !important;
  }

  .items-card .el-table td {
    padding: 16px 12px !important;
    border-bottom: 1px solid #f3f4f6 !important;
    font-size: 13px !important;
  }

  .items-card .el-table .cell {
    line-height: 1.5 !important;
  }

  .items-card .el-table tr:hover {
    background: #f9fafb !important;
  }


  .items-card .product-name {
    color: #374151 !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    line-height: 1.4;
  }

  .items-card .no-data {
    color: #9ca3af !important;
    font-size: 13px !important;
    font-style: italic;
  }

  .items-card .import-time {
    color: #6b7280 !important;
    font-size: 12px !important;
    font-weight: 400 !important;
  }

  .items-card .el-tag {
    font-size: 12px !important;
    padding: 4px 8px !important;
    font-weight: 500 !important;
  }

  .items-card .el-button--mini {
    padding: 6px 10px !important;
    font-size: 12px !important;
  }

  /* 对话框底部 - 简洁版 */
  .dialog-footer {
    padding: 16px 20px !important;
    background: #f8fafc;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .dialog-footer .item-count-info {
    color: #6b7280;
    font-size: 13px !important;
    font-weight: 400;
  }

  .dialog-footer .el-button {
    font-size: 13px !important;
    padding: 8px 16px !important;
    font-weight: 500 !important;
  }
}

.batch-summary-card {
  .clearfix {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;

    i {
      margin-right: 8px;
      color: #409EFF;
    }
  }

  .header-actions {
    display: flex;
    gap: 8px;
  }

  .summary-item {
    margin-bottom: 15px;

    .label {
      display: block;
      font-size: 12px;
      color: #909399;
      margin-bottom: 4px;
      font-weight: 500;
    }

    .value {
      font-size: 14px;
      color: #303133;
      font-weight: 500;
    }

    .tracking-code {
      font-family: 'Monaco', 'Consolas', monospace;
      background: #f5f7fa;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 12px;
      color: #606266;
    }
  }
}

.items-card {
  .header-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;

    i {
      margin-right: 8px;
      color: #67C23A;
    }
  }

  .header-actions {
    display: flex;
    gap: 8px;
  }


  .product-name {
    color: #606266;
    font-size: 13px;
    line-height: 1.4;
  }

  .no-data {
    color: #c0c4cc;
    font-style: italic;
    font-size: 12px;
  }

  .import-time {
    color: #909399;
    font-size: 12px;
  }

  .validation-error {
    .el-tag {
      cursor: help;
    }
  }

  .validation-success {
    .el-tag {
      background: #f0f9ff;
      color: #067f8a;
      border-color: #b3f5ff;
    }
  }
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;

  i {
    font-size: 64px;
    margin-bottom: 20px;
    color: #c0c4cc;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;

  .footer-left {
    .item-count-info {
      color: #909399;
      font-size: 13px;
    }
  }

  .footer-right {
    display: flex;
    gap: 8px;
  }
}

/* 表格样式优化 */
.el-table {
  .el-table__header-wrapper {
    th {
      background: #fafbfc !important;
      color: #303133;
      font-weight: 600;
      font-size: 13px;
    }
  }

  .el-table__row {
    &:hover {
      background: #f5f7fa !important;
    }
  }

  .el-tag {
    font-weight: 500;
  }
}

/* ===================== 分页样式优化 ===================== */
.el-pagination {
  margin-top: 24px;
  padding: 16px 0;
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.el-pagination .el-pager li {
  background: #f8fafc;
  color: #64748b;
  font-weight: 500;
  border-radius: 6px;
  margin: 0 4px;
  transition: all 0.2s ease;
}

.el-pagination .el-pager li:hover,
.el-pagination .el-pager li.active {
  background: #3b82f6;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.el-pagination .btn-prev,
.el-pagination .btn-next {
  background: #f8fafc;
  border-radius: 6px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
}

.el-pagination .btn-prev:hover,
.el-pagination .btn-next:hover {
  background: #3b82f6;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

/* ===================== 表单样式优化 ===================== */
.el-form-item__label {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.el-input__inner,
.el-textarea__inner {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  padding: 12px 16px;
  transition: all 0.3s ease;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.el-select .el-input__inner {
  padding-right: 40px;
}

/* ===================== 加载状态优化 ===================== */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
}

.el-loading-spinner .circular {
  width: 50px;
  height: 50px;
}

.el-loading-text {
  color: #374151;
  font-weight: 500;
}

/* ===================== 消息提示优化 ===================== */
.el-message {
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: none;
  padding: 16px 20px;
}

.el-message--success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
}

.el-message--warning {
  background: linear-gradient(135deg, #fef3c7 0%, #fcd34d 100%);
  color: #92400e;
}

.el-message--error {
  background: linear-gradient(135deg, #fecaca 0%, #f87171 100%);
  color: #991b1b;
}

/* ===================== 空状态优化 ===================== */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #6b7280;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
  border-radius: 12px;
  margin: 20px 0;

  i {
    font-size: 72px;
    margin-bottom: 24px;
    color: #d1d5db;
    background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 16px;
    margin: 0;
    font-weight: 500;
  }
}

/* ===================== 工具提示优化 ===================== */
.el-tooltip__popper {
  border-radius: 8px;
  font-size: 13px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid #e2e8f0;
}

/* ===================== 进度条优化 ===================== */
.el-progress-bar__outer {
  border-radius: 8px;
  background-color: #f1f5f9;
}

.el-progress-bar__inner {
  border-radius: 8px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

/* ===================== 卡片阴影动画优化 ===================== */
.el-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.el-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

/* 响应式优化 */
@media (max-width: 1200px) {
  .package-detail-dialog .el-dialog {
    width: 98% !important;
    margin: 10px auto;
  }

  .batch-summary-card .el-row .el-col {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// MixedPackageList.vue?40076b9f